(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clearvero-golden-product"]) return;
  try {
    
  if (!customElements.get('clearvero-golden-product')) {
    customElements.define(
      'clearvero-golden-product',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.cvInitialized === 'true') return;
          this.dataset.cvInitialized = 'true';
          this.form = this.querySelector('.cv-golden__form');
          this.variantInput = this.querySelector('[data-cv-variant-id]');
          this.variantSelect = this.querySelector('[data-cv-variant-select]');
          this.quantityInput = this.querySelector('[data-cv-quantity]');
          this.unitPrice = this.querySelector('[data-cv-unit-price]');
          this.lineTotal = this.querySelector('[data-cv-line-total]');
          this.sticky = this.querySelector('[data-cv-sticky]');
          this.stickyTotal = this.querySelector('[data-cv-sticky-total]');
          this.addButton = this.querySelector('[data-cv-add-to-cart]');
          this.stickyButton = this.querySelector('[data-cv-sticky-submit]');
          this.bindMedia();
          this.bindQuantity();
          this.bindVariant();
          this.bindSticky();
          this.syncState();
          setTimeout(() => this.syncState(), 0);
        }

        bindMedia() {
          this.querySelectorAll('[data-cv-media-button]').forEach((button) => {
            button.addEventListener('click', () => {
              const index = button.dataset.cvMediaButton;
              this.querySelectorAll('[data-cv-media-item]').forEach((item) => {
                item.hidden = item.dataset.cvMediaItem !== index;
              });
              this.querySelectorAll('[data-cv-media-button]').forEach((control) => {
                control.setAttribute('aria-selected', String(control === button));
              });
            });
          });
        }

        bindQuantity() {
          this.querySelector('[data-cv-quantity-decrease]')?.addEventListener('click', () => this.stepQuantity(-1));
          this.querySelector('[data-cv-quantity-increase]')?.addEventListener('click', () => this.stepQuantity(1));
          this.quantityInput?.addEventListener('input', () => this.syncState());
        }

        bindVariant() {
          this.variantSelect?.addEventListener('change', () => this.syncState());
          this.form?.addEventListener('submit', (event) => {
            if (document.activeElement === this.variantSelect) event.preventDefault();
          });
        }

        bindSticky() {
          this.stickyButton?.addEventListener('click', () => this.form?.requestSubmit());
          if ((this.dataset.cvExceptions || '').split(' ').includes('disable-sticky')) return;
          if (!this.form || !this.sticky || !('IntersectionObserver' in window)) return;
          this.stickyObserver = new IntersectionObserver(([entry]) => {
            this.sticky.hidden = entry.isIntersecting;
          }, { threshold: 0.1 });
          this.stickyObserver.observe(this.form);
        }

        stepQuantity(delta) {
          if (!this.quantityInput) return;
          const minimum = Number(this.quantityInput.min || 1);
          const next = Math.max(minimum, Number(this.quantityInput.value || minimum) + delta);
          this.quantityInput.value = String(next);
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        syncState() {
          const option = this.variantSelect?.selectedOptions[0];
          const selectedVariantId = option?.value || this.dataset.cvCurrentVariantId;
          if (selectedVariantId && this.variantInput) this.variantInput.value = selectedVariantId;
          const priceCents = Number(option?.dataset.priceCents || this.lineTotal?.dataset.priceCents || 0);
          const available = option ? option.dataset.available === 'true' : !this.addButton?.disabled;
          const quantity = Math.max(1, Number(this.quantityInput?.value || 1));
          if (this.quantityInput) this.quantityInput.value = String(quantity);
          const formatter = new Intl.NumberFormat(this.dataset.locale || undefined, {
            style: 'currency',
            currency: this.dataset.currency
          });
          const formattedUnit = formatter.format(priceCents / 100);
          const formattedTotal = formatter.format((priceCents * quantity) / 100);
          if (priceCents > 0) {
            if (this.unitPrice) this.unitPrice.textContent = formattedUnit;
            if (this.lineTotal) this.lineTotal.textContent = formattedTotal;
            if (this.stickyTotal) this.stickyTotal.textContent = formattedTotal;
          }
          if (this.addButton) this.addButton.disabled = !available;
          if (this.stickyButton) this.stickyButton.disabled = !available;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-yvr120-purchase"] && !Shopify.designMode) return;
  try {
    
// The existing app retains opening, closing, keyboard trapping and messaging.
// This product-only element supplies initial focus and scrolls focused chips.
if (!customElements.get('cv-yvr120-vero-focus')) {
  customElements.define('cv-yvr120-vero-focus', class extends HTMLElement {
    static owners = new WeakMap();
    connectedCallback() {
      this.disconnectedCallback();
      this.root = this.closest('[data-cv-e10-s4-controller]');
      if (!this.root || this.root.dataset.productId !== '15405022478564') return;
      this.discover();
    }

    disconnectedCallback() {
      if (this.host && this.constructor.owners.get(this.host) === this) {
        this.constructor.owners.delete(this.host);
      }
      this.discovery?.disconnect();
      this.hostObserver?.disconnect();
      this.parentObserver?.disconnect();
      this.listeners?.abort();
      clearTimeout(this.discoveryTimer);
      cancelAnimationFrame(this.focusFrame);
      this.discovery = this.hostObserver = this.parentObserver = null;
      this.listeners = this.host = this.root = null;
      this.wasOpen = false;
    }

    discover() {
      if (!this.isConnected || !this.root?.isConnected) return;
      if (this.findHost()) return;
      this.discovery?.disconnect();
      clearTimeout(this.discoveryTimer);
      this.discovery = new MutationObserver(() => this.findHost());
      this.discovery.observe(document.body, { childList: true, subtree: true });
      this.discoveryTimer = setTimeout(() => {
        this.discovery?.disconnect();
        this.discovery = null;
      }, 10000);
    }

    findHost() {
      const hosts = document.querySelectorAll('clearvero-chat');
      if (hosts.length !== 1) return false;
      const host = hosts[0];
      const owner = this.constructor.owners.get(host);
      if (owner && owner !== this && owner.isConnected) return false;
      if (!host.querySelector('.cv-launcher[aria-label="Ask Vero"]') ||
          !host.querySelector('.cv-panel[role="dialog"][aria-modal="true"]')) return false;
      this.discovery?.disconnect();
      this.discovery = null;
      clearTimeout(this.discoveryTimer);
      if (this.host === host) return true;
      this.hostObserver?.disconnect();
      this.parentObserver?.disconnect();
      this.listeners?.abort();
      cancelAnimationFrame(this.focusFrame);
      if (this.host && this.constructor.owners.get(this.host) === this) {
        this.constructor.owners.delete(this.host);
      }
      this.host = host;
      this.constructor.owners.set(host, this);
      this.wasOpen = this.isOpen();
      this.listeners = new AbortController();
      host.addEventListener('focusin', event => this.revealChip(event), {
        signal: this.listeners.signal
      });
      this.hostObserver = new MutationObserver(() => this.observeOpen());
      this.hostObserver.observe(host, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['data-open', 'aria-expanded']
      });
      const parent = host.parentElement?.parentElement || host.parentElement;
      if (parent) {
        this.parentObserver = new MutationObserver(() => {
          if (this.host?.isConnected) return;
          this.hostObserver?.disconnect();
          this.parentObserver?.disconnect();
          this.listeners?.abort();
          cancelAnimationFrame(this.focusFrame);
          if (this.host && this.constructor.owners.get(this.host) === this) {
            this.constructor.owners.delete(this.host);
          }
          this.host = null;
          this.wasOpen = false;
          this.discover();
        });
        this.parentObserver.observe(parent, { childList: true });
        if (host.parentElement && host.parentElement !== parent) {
          this.parentObserver.observe(host.parentElement, { childList: true });
        }
      }
      return true;
    }

    panel() {
      return this.host?.querySelector('.cv-panel[role="dialog"][aria-modal="true"]');
    }

    visible(element) {
      if (!element?.isConnected || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none';
    }

    isOpen() {
      if (!this.host?.isConnected || document.querySelectorAll('clearvero-chat').length !== 1) return false;
      return this.panel()?.getAttribute('data-open') === 'true' &&
        this.host?.querySelector('.cv-launcher')?.getAttribute('aria-expanded') === 'true';
    }

    observeOpen() {
      const open = this.isOpen();
      if (open && !this.wasOpen) {
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = requestAnimationFrame(() => this.focusOnOpen());
        });
      } else if (!open) {
        cancelAnimationFrame(this.focusFrame);
      }
      this.wasOpen = open;
    }

    focusOnOpen() {
      if (!this.root?.isConnected || !this.isOpen()) return;
      const panel = this.panel(), active = document.activeElement;
      if (!this.visible(panel) || panel.contains(active)) return;
      const launcher = this.host.querySelector('.cv-launcher');
      if (active && active !== document.body && active !== document.documentElement &&
          active !== this.host && active !== launcher) return;
      const anotherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]'))
        .some(element => element !== panel && this.visible(element));
      if (anotherModal) return;
      const close = panel.querySelector('button[aria-label="Close Vero"]');
      if (this.visible(close) && !close.disabled) close.focus({ preventScroll: true });
    }

    revealChip(event) {
      const button = event.target instanceof Element ? event.target.closest('button') : null;
      const strip = button?.closest('.cv-suggestions'), panel = this.panel();
      if (!this.isOpen() || !strip || !panel?.contains(strip)) return;
      const item = button.getBoundingClientRect(), bounds = strip.getBoundingClientRect();
      const left = bounds.left + 4, right = bounds.right - 4;
      if (item.left < left) strip.scrollLeft += item.left - left;
      else if (item.right > right) strip.scrollLeft += item.right - right;
    }
  });
}
(() => {
  const PENDING_VERSION = 1;
  const PENDING_TTL_MS = 30 * 60 * 1000;
  const COMPLETED_DEDUP_MS = 10 * 1000;
  const memoryPending = new Map();

  const parseList = (value) => (value || '').split('|').map((item) => item.trim()).filter(Boolean);
  const parseMap = (value) => {
    const result = {};
    parseList(value).forEach((pair) => {
      const separator = pair.indexOf('=>');
      if (separator > 0) result[pair.slice(0, separator).trim()] = pair.slice(separator + 2).trim();
    });
    return result;
  };
  const parseJSON = (element, fallback) => {
    try { return JSON.parse(element ? element.textContent : ''); } catch (_) { return fallback; }
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'}).format(Number(cents || 0) / 100);
  const cameraCount = (variant) => Math.max(1, Number(variant?.cameraCount || 1));
  const asPositiveInteger = (value) => Math.max(1, Number.parseInt(value || '1', 10) || 1);
  const pendingKey = (signature) => `cv-addon-pending:v${PENDING_VERSION}:${signature}`;

  const readPending = (key) => {
    let value = memoryPending.get(key) || null;
    try { value = window.localStorage.getItem(key) || value; } catch (_) {}
    if (!value) return null;
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      if (parsed.version !== PENDING_VERSION || parsed.expiresAt <= Date.now()) {
        clearPending(key);
        return null;
      }
      return parsed;
    } catch (_) {
      clearPending(key);
      return null;
    }
  };

  const writePending = (key, value) => {
    memoryPending.set(key, value);
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  const clearPending = (key) => {
    memoryPending.delete(key);
    try { window.localStorage.removeItem(key); } catch (_) {}
  };

  const cartRoutes = (form) => {
    const action = new URL(form.getAttribute('action') || '/cart/add', window.location.href);
    const pathname = action.pathname.endsWith('/') ? action.pathname.slice(0, -1) : action.pathname;
    const suffix = pathname.endsWith('/cart/add.js') ? '/add.js' : pathname.endsWith('/cart/add') ? '/add' : null;
    if (action.origin !== window.location.origin || !suffix) throw new Error('CART_ROUTE_UNVERIFIED');
    const base = pathname.slice(0, -suffix.length);
    const route = (suffix) => {
      const target = new URL(action.href);
      target.pathname = base + suffix;
      return target.pathname + target.search;
    };
    return {read: route('.js'), add: route('/add.js'), page: route('')};
  };

  const cartSnapshot = async (routes) => {
    const response = await fetch(routes.read, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('CART_READ_FAILED');
    const cart = await response.json();
    const quantities = {};
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '');
      if (id) quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });
    return {cart, quantities};
  };

  const makeSignature = (items) => items
    .map((item) => `${item.variantId}:${item.quantity}`)
    .sort()
    .join('|');

  const announce = (status, message) => {
    if (status) status.textContent = message;
  };

  const createPending = (key, signature, items, snapshot) => {
    const requested = {};
    items.forEach((item) => {
      requested[item.variantId] = (requested[item.variantId] || 0) + item.quantity;
    });
    const targets = {};
    Object.entries(requested).forEach(([variantId, quantity]) => {
      targets[variantId] = items.some(item => item.variantId === variantId && item.once) ? Math.max(Number(snapshot.quantities[variantId] || 0), quantity) : Number(snapshot.quantities[variantId] || 0) + quantity;
    });
    const pending = {
      version: PENDING_VERSION,
      signature,
      createdAt: Date.now(),
      expiresAt: Date.now() + PENDING_TTL_MS,
      baseline: snapshot.quantities,
      targets,
      items
    };
    writePending(key, pending);
    return pending;
  };

  const remainingItems = (pending, snapshot) => pending.items.filter((item, index, all) => (
    all.findIndex((candidate) => candidate.variantId === item.variantId) === index
    && Number(snapshot.quantities[item.variantId] || 0) < Number(pending.targets[item.variantId] || 0)
  ));

  const intendedAddedCount = (pending, snapshot) => Object.keys(pending.targets).reduce((total, variantId) => {
    const baseline = Number(pending.baseline[variantId] || 0);
    const target = Number(pending.targets[variantId] || 0);
    const current = Number(snapshot.quantities[variantId] || 0);
    return total + Math.max(0, Math.min(target, current) - baseline);
  }, 0);

  const postMissingQuantity = async (item, quantity, parentForm, routes) => {
    let body;
    let headers = {Accept: 'application/json'};
    if (item.role === 'parent') {
      body = new FormData(parentForm);
      body.set('id', item.variantId);
      body.set('quantity', String(quantity));
    } else {
      body = new URLSearchParams({id: item.variantId, quantity: String(quantity)});
      headers = {...headers, 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};
    }
    try {
      await fetch(routes.add, {method: 'POST', body, headers});
    } catch (_) {
    }
  };

  const runReconciledAdd = async ({items, parentForm, status, routes}) => {
    const signature = makeSignature(items);
    const key = pendingKey(routes.read + ':' + signature);
    let initialSnapshot;
    try {
      initialSnapshot = await cartSnapshot(routes);
    } catch (_) {
      announce(status, 'Nothing was added because the cart could not be verified. Please try again.');
      return {complete: false, verificationFailed: false};
    }

    const existing = readPending(key);
    if (existing && existing.completed && Object.entries(existing.targets || {}).every(([variantId, target]) => Number(initialSnapshot.quantities[variantId] || 0) >= Number(target))) {
      announce(status, 'This cart update was already completed. Your cart was not changed again.');
      return {complete: true, verificationFailed: false};
    }
    const isRetry = Boolean(existing && existing.signature === signature);
    const pending = isRetry ? existing : createPending(key, signature, items, initialSnapshot);
    let snapshot = initialSnapshot;

    for (const item of pending.items) {
      const current = Number(snapshot.quantities[item.variantId] || 0);
      const target = Number(pending.targets[item.variantId] || 0);
      const missing = Math.max(0, target - current);
      if (!missing) continue;
      await postMissingQuantity(item, missing, parentForm, routes);
      try {
        snapshot = await cartSnapshot(routes);
      } catch (_) {
        announce(status, 'We could not verify the final cart state. Review your cart before trying again.');
        return {complete: false, verificationFailed: true};
      }
    }

    const remaining = remainingItems(pending, snapshot);
    if (!remaining.length) {
      writePending(key, {
        ...pending,
        completed: true,
        completedAt: Date.now(),
        expiresAt: Date.now() + COMPLETED_DEDUP_MS
      });
      announce(status, isRetry
        ? 'The retry added only the remaining items. Your cart is complete.'
        : 'The system and selected additions were added to your cart.');
      return {complete: true, verificationFailed: false};
    }

    const remainingTitles = remaining.map((item) => item.title).join(', ');
    if (intendedAddedCount(pending, snapshot) === 0) {
      announce(status, `Nothing was added. Still needed: ${remainingTitles}. Please try again.`);
    } else {
      announce(status, `Some items are in your cart. Still not added: ${remainingTitles}. Retry here; items already added will not be duplicated.`);
    }
    writePending(key, {...pending, expiresAt: Date.now() + PENDING_TTL_MS});
    return {complete: false, verificationFailed: false};
  };

  const bindings = new Map();
  const release = (productId) => {
    const binding = bindings.get(productId);
    if (!binding) return;
    binding.controller.abort();
    delete binding.root.dataset.cvAddonInitialized;
    delete binding.form.dataset.cvAddonCartBound;
    bindings.delete(productId);
  };

  function initialize(root) {
    const productId = root.dataset.parentProductId;
    const parentForm = document.getElementById(`CVYVR120ProductForm-${productId}`);
    if (!parentForm?.matches('form[action*="/cart/add"]') ||
        parentForm.closest('[data-cv-e10-s4-controller]')?.dataset.productId !== productId) return;
    const previous = bindings.get(productId);
    if (previous?.root === root && previous.form === parentForm) return;
    if (previous) release(productId);
    if (parentForm.dataset.cvAddonCartBound === 'true') return;

    const cards = Array.from(root.querySelectorAll('[data-cv-addon-card]'));
    const parentVariants = parseJSON(root.querySelector('[data-cv-parent-variants]'), []);
    const status = root.querySelector('[data-cv-addon-status]');
    const controller = new AbortController();
    const options = {signal: controller.signal};
    bindings.set(productId, {root, form: parentForm, controller});
    root.dataset.cvAddonInitialized = 'true';
    parentForm.dataset.cvAddonCartBound = 'true';

    const currentParentId = () => {
      const inputValue = parentForm?.querySelector('[name="id"]')?.value;
      const urlValue = new URL(window.location.href).searchParams.get('variant');
      return String(inputValue || urlValue || root.dataset.currentParentVariantId || '');
    };

    const update = () => {
      const parentId = currentParentId();
      const parentVariant = parentVariants.find((variant) => String(variant.id) === parentId);
      let visibleCount = 0;
      cards.forEach((card) => {
        const applicable = parseList(card.dataset.applicableParentVariantIds);
        const mapping = parseMap(card.dataset.accessoryVariantMap);
        const variants = parseJSON(card.querySelector('[data-cv-addon-variants]'), []);
        const sku = mapping[parentId];
        const accessoryVariant = variants.find((variant) => variant.sku === sku);
        const checkbox = card.querySelector('[data-cv-addon-checkbox]');
        const quantity = card.querySelector('[data-cv-addon-quantity]');
        const quantityWrap = card.querySelector('[data-cv-addon-quantity-wrap]');
        const quantityNote = card.querySelector('[data-cv-addon-quantity-note]');
        const availability = card.querySelector('[data-cv-addon-availability]');
        const isApplicable = Boolean(parentVariant) && applicable.includes(parentId) && Boolean(accessoryVariant);
        card.hidden = !isApplicable;
        if (!isApplicable) {
          checkbox.checked = false;
          checkbox.disabled = true;
          return;
        }
        visibleCount += 1;
        checkbox.value = String(accessoryVariant.id);
        checkbox.disabled = !accessoryVariant.available;
        if (!accessoryVariant.available) checkbox.checked = false;
        card.querySelector('[data-cv-addon-price]').textContent = money(accessoryVariant.price);
        availability.textContent = accessoryVariant.available ? 'Available' : 'Currently unavailable';

        const logic = card.dataset.quantityLogic;
        if (logic === 'USER_SELECTABLE') {
          quantityWrap.hidden = false;
          quantity.readOnly = false;
          quantityNote.textContent = '';
        } else {
          const nextQuantity = logic === 'PER_CAMERA' ? cameraCount(parentVariant) * asPositiveInteger(parentForm?.querySelector('[name="quantity"]')?.value) : 1;
          quantity.value = String(nextQuantity);
          quantity.readOnly = true;
          quantityWrap.hidden = false;
          quantityNote.textContent = logic === 'PER_CAMERA' ? ` Matches the selected quantity of ${nextQuantity} recorder(s).` : ' Fixed at one.';
        }
      });
      root.hidden = visibleCount === 0;
      root.dataset.currentParentVariantId = parentId;
    };

    update();
    const scheduleUpdate = () => window.requestAnimationFrame(() => {
      if (!controller.signal.aborted) update();
    });
    parentForm.addEventListener('input', scheduleUpdate, options);
    document.addEventListener('change', scheduleUpdate, options);
    document.addEventListener('variant:change', scheduleUpdate, options);
    window.addEventListener('popstate', update, options);

    window.addEventListener('submit', async (event) => {
      if (event.target !== parentForm) return;
      update();
      const selected = cards.filter((card) => !card.hidden && card.querySelector('[data-cv-addon-checkbox]')?.checked);
      if (!selected.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (parentForm.dataset.cvAddonCartInFlight === 'true') {
        announce(status, 'Your cart update is already in progress.');
        return;
      }
      parentForm.dataset.cvAddonCartInFlight = 'true';

      let routes;
      try { routes = cartRoutes(parentForm); } catch (_) {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        announce(status, 'Nothing was added because the cart route could not be verified. Please refresh the page and try again.');
        return;
      }
      const parentId = currentParentId();
      const parentQuantity = asPositiveInteger(parentForm.querySelector('[name="quantity"]')?.value);
      const items = [{
        variantId: parentId,
        quantity: parentQuantity,
        title: 'Recorder',
        role: 'parent'
      }];
      selected.forEach((card) => {
        items.push({
          variantId: String(card.querySelector('[data-cv-addon-checkbox]').value),
          quantity: asPositiveInteger(card.querySelector('[data-cv-addon-quantity]')?.value),
          title: card.dataset.accessoryTitle || 'Selected addition',
          role: 'accessory', once: card.dataset.quantityLogic === 'ONCE_PER_INSTALLATION'
        });
      });

      const buttons = Array.from(parentForm.elements).filter((button) => button.type === 'submit' && !button.disabled);
      buttons.forEach((button) => { button.disabled = true; });
      announce(status, 'Checking your cart and adding only missing items…');
      let keepDisabled = false;
      let navigating = false;
      const action = async () => {
        const result = await runReconciledAdd({items, parentForm, status, routes});
        keepDisabled = result.verificationFailed;
        if (result.complete) {
          await window.CvFunnelTrack?.('cv_bundle_add', {parent_product_id: root.dataset.parentProductId, accessory_variant_ids: items.filter(i => i.role !== 'parent').map(i => i.variantId)});
          navigating = true;
          window.location.assign(routes.page);
        }
      };

      try {
        const lockName = `cv-addon-cart:${makeSignature(items)}`;
        if (navigator.locks && navigator.locks.request) {
          await navigator.locks.request(lockName, action);
        } else {
          await action();
        }
      } finally {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        if (!navigating && !keepDisabled) buttons.forEach((button) => { button.disabled = false; });
      }
    }, {capture: true, signal: controller.signal});
  }

  const initializeAll = () => {
    for (const [id, binding] of bindings) {
      if (!binding.root.isConnected || !binding.form.isConnected) release(id);
    }
    document.querySelectorAll('[data-cv-yvr120-addon-section]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [id, binding] of bindings) {
      if (event.target.contains(binding.root) || event.target.contains(binding.form)) release(id);
    }
  });
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-yvr121-guidance"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PENDING_VERSION = 1;
  const PENDING_TTL_MS = 30 * 60 * 1000;
  const COMPLETED_DEDUP_MS = 10 * 1000;
  const memoryPending = new Map();

  const parseList = (value) => (value || '').split('|').map((item) => item.trim()).filter(Boolean);
  const parseMap = (value) => {
    const result = {};
    parseList(value).forEach((pair) => {
      const separator = pair.indexOf('=>');
      if (separator > 0) result[pair.slice(0, separator).trim()] = pair.slice(separator + 2).trim();
    });
    return result;
  };
  const parseJSON = (element, fallback) => {
    try { return JSON.parse(element ? element.textContent : ''); } catch (_) { return fallback; }
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'}).format(Number(cents || 0) / 100);
  const cameraCount = (variant) => Math.max(1, Number(variant?.cameraCount || 1));
  const asPositiveInteger = (value) => Math.max(1, Number.parseInt(value || '1', 10) || 1);
  const pendingKey = (signature) => `cv-addon-pending:v${PENDING_VERSION}:${signature}`;

  const readPending = (key) => {
    let value = memoryPending.get(key) || null;
    try { value = window.localStorage.getItem(key) || value; } catch (_) {}
    if (!value) return null;
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      if (parsed.version !== PENDING_VERSION || parsed.expiresAt <= Date.now()) {
        clearPending(key);
        return null;
      }
      return parsed;
    } catch (_) {
      clearPending(key);
      return null;
    }
  };

  const writePending = (key, value) => {
    memoryPending.set(key, value);
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  const clearPending = (key) => {
    memoryPending.delete(key);
    try { window.localStorage.removeItem(key); } catch (_) {}
  };

  const cartRoutes = (form) => {
    const action = new URL(form.getAttribute('action') || '/cart/add', window.location.href);
    const pathname = action.pathname.endsWith('/') ? action.pathname.slice(0, -1) : action.pathname;
    const suffix = pathname.endsWith('/cart/add.js') ? '/add.js' : pathname.endsWith('/cart/add') ? '/add' : null;
    if (action.origin !== window.location.origin || !suffix) throw new Error('CART_ROUTE_UNVERIFIED');
    const base = pathname.slice(0, -suffix.length);
    const route = (suffix) => {
      const target = new URL(action.href);
      target.pathname = base + suffix;
      return target.pathname + target.search;
    };
    return {read: route('.js'), add: route('/add.js'), page: route('')};
  };

  const cartSnapshot = async (routes) => {
    const response = await fetch(routes.read, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('CART_READ_FAILED');
    const cart = await response.json();
    const quantities = {};
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '');
      if (id) quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });
    return {cart, quantities};
  };

  const makeSignature = (items) => items
    .map((item) => `${item.variantId}:${item.quantity}`)
    .sort()
    .join('|');

  const announce = (status, message) => {
    if (status) status.textContent = message;
  };

  const createPending = (key, signature, items, snapshot) => {
    const requested = {};
    items.forEach((item) => {
      requested[item.variantId] = (requested[item.variantId] || 0) + item.quantity;
    });
    const targets = {};
    Object.entries(requested).forEach(([variantId, quantity]) => {
      targets[variantId] = items.some(item => item.variantId === variantId && item.once) ? Math.max(Number(snapshot.quantities[variantId] || 0), quantity) : Number(snapshot.quantities[variantId] || 0) + quantity;
    });
    const pending = {
      version: PENDING_VERSION,
      signature,
      createdAt: Date.now(),
      expiresAt: Date.now() + PENDING_TTL_MS,
      baseline: snapshot.quantities,
      targets,
      items
    };
    writePending(key, pending);
    return pending;
  };

  const remainingItems = (pending, snapshot) => pending.items.filter((item, index, all) => (
    all.findIndex((candidate) => candidate.variantId === item.variantId) === index
    && Number(snapshot.quantities[item.variantId] || 0) < Number(pending.targets[item.variantId] || 0)
  ));

  const intendedAddedCount = (pending, snapshot) => Object.keys(pending.targets).reduce((total, variantId) => {
    const baseline = Number(pending.baseline[variantId] || 0);
    const target = Number(pending.targets[variantId] || 0);
    const current = Number(snapshot.quantities[variantId] || 0);
    return total + Math.max(0, Math.min(target, current) - baseline);
  }, 0);

  const postMissingQuantity = async (item, quantity, parentForm, routes) => {
    let body;
    let headers = {Accept: 'application/json'};
    if (item.role === 'parent') {
      body = new FormData(parentForm);
      body.set('id', item.variantId);
      body.set('quantity', String(quantity));
    } else {
      body = new URLSearchParams({id: item.variantId, quantity: String(quantity)});
      headers = {...headers, 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};
    }
    try {
      await fetch(routes.add, {method: 'POST', body, headers});
    } catch (_) {
    }
  };

  const runReconciledAdd = async ({items, parentForm, status, routes}) => {
    const signature = makeSignature(items);
    const key = pendingKey(routes.read + ':' + signature);
    let initialSnapshot;
    try {
      initialSnapshot = await cartSnapshot(routes);
    } catch (_) {
      announce(status, 'Nothing was added because the cart could not be verified. Please try again.');
      return {complete: false, verificationFailed: false};
    }

    const existing = readPending(key);
    if (existing && existing.completed && Object.entries(existing.targets || {}).every(([variantId, target]) => Number(initialSnapshot.quantities[variantId] || 0) >= Number(target))) {
      announce(status, 'This cart update was already completed. Your cart was not changed again.');
      return {complete: true, verificationFailed: false};
    }
    const isRetry = Boolean(existing && existing.signature === signature);
    const pending = isRetry ? existing : createPending(key, signature, items, initialSnapshot);
    let snapshot = initialSnapshot;

    for (const item of pending.items) {
      const current = Number(snapshot.quantities[item.variantId] || 0);
      const target = Number(pending.targets[item.variantId] || 0);
      const missing = Math.max(0, target - current);
      if (!missing) continue;
      await postMissingQuantity(item, missing, parentForm, routes);
      try {
        snapshot = await cartSnapshot(routes);
      } catch (_) {
        announce(status, 'We could not verify the final cart state. Review your cart before trying again.');
        return {complete: false, verificationFailed: true};
      }
    }

    const remaining = remainingItems(pending, snapshot);
    if (!remaining.length) {
      writePending(key, {
        ...pending,
        completed: true,
        completedAt: Date.now(),
        expiresAt: Date.now() + COMPLETED_DEDUP_MS
      });
      announce(status, isRetry
        ? 'The retry added only the remaining items. Your cart is complete.'
        : 'The system and selected additions were added to your cart.');
      return {complete: true, verificationFailed: false};
    }

    const remainingTitles = remaining.map((item) => item.title).join(', ');
    if (intendedAddedCount(pending, snapshot) === 0) {
      announce(status, `Nothing was added. Still needed: ${remainingTitles}. Please try again.`);
    } else {
      announce(status, `Some items are in your cart. Still not added: ${remainingTitles}. Retry here; items already added will not be duplicated.`);
    }
    writePending(key, {...pending, expiresAt: Date.now() + PENDING_TTL_MS});
    return {complete: false, verificationFailed: false};
  };

  let binding = null;
  const disconnect = () => {
    if (!binding) return;
    binding.listeners.abort();
    delete binding.root.dataset.cvAddonInitialized;
    delete binding.parentForm.dataset.cvAddonCartBound;
    binding = null;
  };
  function initialize(root, parentForm) {
    const listeners = new AbortController();
    const {signal} = listeners;
    binding = {root, parentForm, listeners};
    root.dataset.cvAddonInitialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-cv-addon-card]'));
    const parentVariants = parseJSON(root.querySelector('[data-cv-parent-variants]'), []);
    const status = root.querySelector('[data-cv-addon-status]');

    const currentParentId = () => {
      const inputValue = parentForm?.querySelector('[name="id"]')?.value;
      const urlValue = new URL(window.location.href).searchParams.get('variant');
      return String(inputValue || urlValue || root.dataset.currentParentVariantId || '');
    };

    const update = () => {
      const parentId = currentParentId();
      const parentVariant = parentVariants.find((variant) => String(variant.id) === parentId);
      let visibleCount = 0;
      cards.forEach((card) => {
        const applicable = parseList(card.dataset.applicableParentVariantIds);
        const mapping = parseMap(card.dataset.accessoryVariantMap);
        const variants = parseJSON(card.querySelector('[data-cv-addon-variants]'), []);
        const sku = mapping[parentId];
        const accessoryVariant = variants.find((variant) => variant.sku === sku);
        const checkbox = card.querySelector('[data-cv-addon-checkbox]');
        const quantity = card.querySelector('[data-cv-addon-quantity]');
        const quantityWrap = card.querySelector('[data-cv-addon-quantity-wrap]');
        const quantityNote = card.querySelector('[data-cv-addon-quantity-note]');
        const availability = card.querySelector('[data-cv-addon-availability]');
        const isApplicable = Boolean(parentVariant) && applicable.includes(parentId) && Boolean(accessoryVariant);
        card.hidden = !isApplicable;
        if (!isApplicable) {
          checkbox.checked = false;
          checkbox.disabled = true;
          return;
        }
        visibleCount += 1;
        checkbox.value = String(accessoryVariant.id);
        checkbox.disabled = !accessoryVariant.available;
        if (!accessoryVariant.available) checkbox.checked = false;
        card.querySelector('[data-cv-addon-price]').textContent = money(accessoryVariant.price);
        availability.textContent = accessoryVariant.available ? 'Available' : 'Currently unavailable';

        const logic = card.dataset.quantityLogic;
        if (logic === 'USER_SELECTABLE') {
          quantityWrap.hidden = false;
          quantity.readOnly = false;
          quantityNote.textContent = '';
        } else {
          const nextQuantity = logic === 'PER_CAMERA' ? cameraCount(parentVariant) * asPositiveInteger(parentForm?.querySelector('[name="quantity"]')?.value) : 1;
          quantity.value = String(nextQuantity);
          quantity.readOnly = true;
          quantityWrap.hidden = false;
          quantityNote.textContent = logic === 'PER_CAMERA' ? ` Matches the selected quantity of ${nextQuantity} recorder(s).` : ' Fixed at one.';
        }
      });
      root.hidden = visibleCount === 0;
      root.dataset.currentParentVariantId = parentId;
    };

    update();
    document.addEventListener('change', () => window.requestAnimationFrame(update), {signal});
    document.addEventListener('variant:change', () => window.requestAnimationFrame(update), {signal});
    window.addEventListener('popstate', update, {signal});

    parentForm.dataset.cvAddonCartBound = 'true';
    window.addEventListener('submit', async (event) => {
      if (event.target !== parentForm) return;
      if (parentForm.dataset.cvAddonCartInFlight === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        announce(status, 'Your cart update is already in progress.');
        return;
      }
      update();
      const selected = cards.filter((card) => !card.hidden && card.querySelector('[data-cv-addon-checkbox]')?.checked);
      if (!selected.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      parentForm.dataset.cvAddonCartInFlight = 'true';

      let routes;
      try { routes = cartRoutes(parentForm); } catch (_) {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        announce(status, 'Nothing was added because the cart route could not be verified. Please refresh the page and try again.');
        return;
      }
      const parentId = currentParentId();
      const parentQuantity = asPositiveInteger(parentForm.querySelector('[name="quantity"]')?.value);
      const items = [{
        variantId: parentId,
        quantity: parentQuantity,
        title: 'Recorder',
        role: 'parent'
      }];
      selected.forEach((card) => {
        items.push({
          variantId: String(card.querySelector('[data-cv-addon-checkbox]').value),
          quantity: asPositiveInteger(card.querySelector('[data-cv-addon-quantity]')?.value),
          title: card.dataset.accessoryTitle || 'Selected addition',
          role: 'accessory', once: card.dataset.quantityLogic === 'ONCE_PER_INSTALLATION'
        });
      });

      const buttons = Array.from(parentForm.elements).filter((button) => button.type === 'submit' && !button.disabled);
      buttons.forEach((button) => { button.disabled = true; });
      announce(status, 'Checking your cart and adding only missing items…');
      let keepDisabled = false;
      let navigating = false;
      const action = async () => {
        const result = await runReconciledAdd({items, parentForm, status, routes});
        keepDisabled = result.verificationFailed;
        if (result.complete) {
          await window.CvFunnelTrack?.('cv_bundle_add', {parent_product_id: root.dataset.parentProductId, accessory_variant_ids: items.filter(i => i.role !== 'parent').map(i => i.variantId)});
          navigating = true;
          window.location.assign(routes.page);
        }
      };

      try {
        const lockName = `cv-addon-cart:${makeSignature(items)}`;
        if (navigator.locks && navigator.locks.request) {
          await navigator.locks.request(lockName, action);
        } else {
          await action();
        }
      } finally {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        if (!navigating && !keepDisabled) buttons.forEach((button) => { button.disabled = false; });
      }
    }, {capture: true, signal});
  }

  // The cards and their native product form live in separately reloadable sections.
  const initializeAll = () => {
    const root = document.querySelector('[data-cv-yvr121-addon-section]');
    const parentForm = root && document.getElementById(`CVYVR121ProductForm-${root.dataset.parentProductId}`);
    if (binding && root === binding.root && parentForm === binding.parentForm) return;
    disconnect();
    if (root && parentForm) initialize(root, parentForm);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once: true}); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', (event) => {
    if (binding && (event.target.contains(binding.root) || event.target.contains(binding.parentForm))) disconnect();
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-yvr121-purchase"] && !Shopify.designMode) return;
  try {
    
// The existing app retains opening, closing, keyboard trapping and messaging.
// This product-only element supplies initial focus and scrolls focused chips.
if (!customElements.get('cv-yvr121-vero-focus')) {
  customElements.define('cv-yvr121-vero-focus', class extends HTMLElement {
    static owners = new WeakMap();
    connectedCallback() {
      this.disconnectedCallback();
      this.root = this.closest('[data-cv-e10-s4-controller]');
      if (!this.root || this.root.dataset.productId !== '15416458445028') return;
      this.discover();
    }

    disconnectedCallback() {
      if (this.host && this.constructor.owners.get(this.host) === this) {
        this.constructor.owners.delete(this.host);
      }
      this.clearClearance();
      this.discovery?.disconnect();
      this.hostObserver?.disconnect();
      this.parentObserver?.disconnect();
      this.listeners?.abort();
      clearTimeout(this.discoveryTimer);
      cancelAnimationFrame(this.focusFrame);
      this.discovery = this.hostObserver = this.parentObserver = null;
      this.listeners = this.host = this.root = null;
      this.wasOpen = false;
    }

    discover() {
      if (!this.isConnected || !this.root?.isConnected) return;
      if (this.findHost()) return;
      this.discovery?.disconnect();
      clearTimeout(this.discoveryTimer);
      this.discovery = new MutationObserver(() => this.findHost());
      this.discovery.observe(document.body, { childList: true, subtree: true });
      this.discoveryTimer = setTimeout(() => {
        this.discovery?.disconnect();
        this.discovery = null;
      }, 10000);
    }

    findHost() {
      const hosts = document.querySelectorAll('clearvero-chat');
      if (hosts.length !== 1) return false;
      const host = hosts[0];
      const owner = this.constructor.owners.get(host);
      if (owner && owner !== this && owner.isConnected) return false;
      if (!host.querySelector('.cv-launcher[aria-label="Ask Vero"]') ||
          !host.querySelector('.cv-panel[role="dialog"][aria-modal="true"]')) return false;
      this.discovery?.disconnect();
      this.discovery = null;
      clearTimeout(this.discoveryTimer);
      if (this.host === host) return true;
      this.hostObserver?.disconnect();
      this.parentObserver?.disconnect();
      this.listeners?.abort();
      cancelAnimationFrame(this.focusFrame);
      if (this.host && this.constructor.owners.get(this.host) === this) {
        this.constructor.owners.delete(this.host);
      }
      this.clearClearance();
      this.host = host;
      this.constructor.owners.set(host, this);
      this.wasOpen = this.isOpen();
      this.listeners = new AbortController();
      host.addEventListener('focusin', event => this.revealChip(event), {
        signal: this.listeners.signal
      });
      this.setupClearance();
      this.hostObserver = new MutationObserver(() => this.observeOpen());
      this.hostObserver.observe(host, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['data-open', 'aria-expanded']
      });
      const parent = host.parentElement?.parentElement || host.parentElement;
      if (parent) {
        this.parentObserver = new MutationObserver(() => {
          if (this.host?.isConnected) return;
          this.hostObserver?.disconnect();
          this.parentObserver?.disconnect();
          this.listeners?.abort();
          cancelAnimationFrame(this.focusFrame);
          if (this.host && this.constructor.owners.get(this.host) === this) {
            this.constructor.owners.delete(this.host);
          }
          this.clearClearance();
          this.host = null;
          this.wasOpen = false;
          this.discover();
        });
        this.parentObserver.observe(parent, { childList: true });
        if (host.parentElement && host.parentElement !== parent) {
          this.parentObserver.observe(host.parentElement, { childList: true });
        }
      }
      return true;
    }

    clearClearance() {
      cancelAnimationFrame(this.clearanceFrame);
      this.clearanceFrame = null;
      this.clearanceResize?.disconnect();
      this.clearanceLauncher?.removeAttribute('data-cv-yvr121-clearance');
      this.clearanceLauncher?.style.removeProperty('--cv-yvr121-lift');
      this.clearanceLauncher = this.clearanceResize = null;
      this.clearanceLift = 0;
    }

    setupClearance() {
      this.clearanceLauncher = this.host.querySelector('.cv-launcher');
      this.clearanceLauncher.setAttribute('data-cv-yvr121-clearance', '15416458445028');
      const signal = this.listeners.signal;
      const queue = () => this.queueClearance();
      document.addEventListener('scroll', queue, { capture: true, passive: true, signal });
      document.addEventListener('toggle', queue, { capture: true, signal });
      window.addEventListener('resize', queue, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', queue, { passive: true, signal });
      this.clearanceResize = new ResizeObserver(queue);
      this.clearanceResize.observe(this.root);
      const guidance = document.querySelector('.cv-yvr121-guidance');
      if (guidance) this.clearanceResize.observe(guidance);
      this.queueClearance();
    }

    queueClearance() {
      if (this.clearanceFrame) return;
      this.clearanceFrame = requestAnimationFrame(() => {
        this.clearanceFrame = null;
        this.updateClearance();
      });
    }

    updateClearance() {
      const launcher = this.clearanceLauncher;
      if (!launcher?.isConnected || !this.root?.isConnected) return;
      const rect = launcher.getBoundingClientRect();
      let lift = 0;
      if (!this.isOpen() && rect.width && rect.height) {
        // Recover its ordinary position from the previous independent translate.
        // This avoids a lift/reset feedback loop as the customer scrolls.
        const base = { left: rect.left, right: rect.right,
          top: rect.top + (this.clearanceLift || 0),
          bottom: rect.bottom + (this.clearanceLift || 0) };
        const form = 'CVYVR121ProductForm-15416458445028';
        const controls = Array.from(document.querySelectorAll(
          `form[id="${form}"] button, form[id="${form}"] input, button[form="${form}"]`
        )).map(element => element.getBoundingClientRect()).filter(r =>
          r.width && r.height && r.bottom > 0 && r.top < innerHeight &&
          r.right > base.left && r.left < base.right
        );
        // Move above every intersecting purchase control, including quantity
        // controls immediately above an Add to Cart button on short screens.
        for (let pass = 0; pass < controls.length; pass++) {
          const overlaps = controls.filter(r => base.bottom - lift + 12 > r.top &&
            base.top - lift - 12 < r.bottom);
          if (!overlaps.length) break;
          const next = Math.max(lift, ...overlaps.map(r => base.bottom - r.top + 12));
          if (next === lift) break;
          lift = Math.min(next, Math.max(0, base.top - 12));
        }
      }
      if (lift !== this.clearanceLift) {
        this.clearanceLift = lift;
        launcher.style.setProperty('--cv-yvr121-lift', `${lift}px`);
      }
    }

    panel() {
      return this.host?.querySelector('.cv-panel[role="dialog"][aria-modal="true"]');
    }

    visible(element) {
      if (!element?.isConnected || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none';
    }

    isOpen() {
      if (!this.host?.isConnected || document.querySelectorAll('clearvero-chat').length !== 1) return false;
      return this.panel()?.getAttribute('data-open') === 'true' &&
        this.host?.querySelector('.cv-launcher')?.getAttribute('aria-expanded') === 'true';
    }

    observeOpen() {
      const open = this.isOpen();
      if (open && !this.wasOpen) {
        cancelAnimationFrame(this.focusFrame);
        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = requestAnimationFrame(() => this.focusOnOpen());
        });
      } else if (!open) {
        cancelAnimationFrame(this.focusFrame);
      }
      this.wasOpen = open;
      this.queueClearance();
    }

    focusOnOpen() {
      if (!this.root?.isConnected || !this.isOpen()) return;
      const panel = this.panel(), active = document.activeElement;
      if (!this.visible(panel) || panel.contains(active)) return;
      const launcher = this.host.querySelector('.cv-launcher');
      if (active && active !== document.body && active !== document.documentElement &&
          active !== this.host && active !== launcher) return;
      const anotherModal = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]'))
        .some(element => element !== panel && this.visible(element));
      if (anotherModal) return;
      const close = panel.querySelector('button[aria-label="Close Vero"]');
      if (this.visible(close) && !close.disabled) close.focus({ preventScroll: true });
    }

    revealChip(event) {
      const button = event.target instanceof Element ? event.target.closest('button') : null;
      const strip = button?.closest('.cv-suggestions'), panel = this.panel();
      if (!this.isOpen() || !strip || !panel?.contains(strip)) return;
      const item = button.getBoundingClientRect(), bounds = strip.getBoundingClientRect();
      const left = bounds.left + 4, right = bounds.right - 4;
      if (item.left < left) strip.scrollLeft += item.left - left;
      else if (item.right > right) strip.scrollLeft += item.right - right;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-z53-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PENDING_VERSION = 1;
  const PENDING_TTL_MS = 30 * 60 * 1000;
  const COMPLETED_DEDUP_MS = 10 * 1000;
  const memoryPending = new Map();

  const parseList = (value) => (value || '').split('|').map((item) => item.trim()).filter(Boolean);
  const parseMap = (value) => {
    const result = {};
    parseList(value).forEach((pair) => {
      const separator = pair.indexOf('=>');
      if (separator > 0) result[pair.slice(0, separator).trim()] = pair.slice(separator + 2).trim();
    });
    return result;
  };
  const parseJSON = (element, fallback) => {
    try { return JSON.parse(element ? element.textContent : ''); } catch (_) { return fallback; }
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'}).format(Number(cents || 0) / 100);
  const cameraCount = (variant) => Math.max(1, Number(variant?.cameraCount || 1));
  const asPositiveInteger = (value) => Math.max(1, Number.parseInt(value || '1', 10) || 1);
  const pendingKey = (signature) => `cv-addon-pending:v${PENDING_VERSION}:${signature}`;

  const readPending = (key) => {
    let value = memoryPending.get(key) || null;
    try { value = window.localStorage.getItem(key) || value; } catch (_) {}
    if (!value) return null;
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      if (parsed.version !== PENDING_VERSION || parsed.expiresAt <= Date.now()) {
        clearPending(key);
        return null;
      }
      return parsed;
    } catch (_) {
      clearPending(key);
      return null;
    }
  };

  const writePending = (key, value) => {
    memoryPending.set(key, value);
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  const clearPending = (key) => {
    memoryPending.delete(key);
    try { window.localStorage.removeItem(key); } catch (_) {}
  };

  const cartRoutes = (form) => {
    const action = new URL(form.getAttribute('action') || '/cart/add', window.location.href);
    const pathname = action.pathname.endsWith('/') ? action.pathname.slice(0, -1) : action.pathname;
    const suffix = pathname.endsWith('/cart/add.js') ? '/add.js' : pathname.endsWith('/cart/add') ? '/add' : null;
    if (action.origin !== window.location.origin || !suffix) throw new Error('CART_ROUTE_UNVERIFIED');
    const base = pathname.slice(0, -suffix.length);
    const route = (suffix) => {
      const target = new URL(action.href);
      target.pathname = base + suffix;
      return target.pathname + target.search;
    };
    return {read: route('.js'), add: route('/add.js'), page: route('')};
  };

  const cartSnapshot = async (routes) => {
    const response = await fetch(routes.read, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('CART_READ_FAILED');
    const cart = await response.json();
    const quantities = {};
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '');
      if (id) quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });
    return {cart, quantities};
  };

  const makeSignature = (items) => items
    .map((item) => `${item.variantId}:${item.quantity}`)
    .sort()
    .join('|');

  const announce = (status, message) => {
    if (status) status.textContent = message;
  };

  const createPending = (key, signature, items, snapshot) => {
    const requested = {};
    items.forEach((item) => {
      requested[item.variantId] = (requested[item.variantId] || 0) + item.quantity;
    });
    const targets = {};
    Object.entries(requested).forEach(([variantId, quantity]) => {
      targets[variantId] = items.some(item => item.variantId === variantId && item.once) ? Math.max(Number(snapshot.quantities[variantId] || 0), quantity) : Number(snapshot.quantities[variantId] || 0) + quantity;
    });
    const pending = {
      version: PENDING_VERSION,
      signature,
      createdAt: Date.now(),
      expiresAt: Date.now() + PENDING_TTL_MS,
      baseline: snapshot.quantities,
      targets,
      items
    };
    writePending(key, pending);
    return pending;
  };

  const remainingItems = (pending, snapshot) => pending.items.filter((item, index, all) => (
    all.findIndex((candidate) => candidate.variantId === item.variantId) === index
    && Number(snapshot.quantities[item.variantId] || 0) < Number(pending.targets[item.variantId] || 0)
  ));

  const intendedAddedCount = (pending, snapshot) => Object.keys(pending.targets).reduce((total, variantId) => {
    const baseline = Number(pending.baseline[variantId] || 0);
    const target = Number(pending.targets[variantId] || 0);
    const current = Number(snapshot.quantities[variantId] || 0);
    return total + Math.max(0, Math.min(target, current) - baseline);
  }, 0);

  const postMissingQuantity = async (item, quantity, parentForm, routes) => {
    let body;
    let headers = {Accept: 'application/json'};
    if (item.role === 'parent') {
      body = new FormData(parentForm);
      body.set('id', item.variantId);
      body.set('quantity', String(quantity));
    } else {
      body = new URLSearchParams({id: item.variantId, quantity: String(quantity)});
      headers = {...headers, 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};
    }
    try {
      await fetch(routes.add, {method: 'POST', body, headers});
    } catch (_) {
      // The response cannot be trusted as proof of cart state. The caller reads /cart.js next.
    }
  };

  const runReconciledAdd = async ({items, parentForm, status, routes}) => {
    const signature = makeSignature(items);
    const key = pendingKey(routes.read + ':' + signature);
    let initialSnapshot;
    try {
      initialSnapshot = await cartSnapshot(routes);
    } catch (_) {
      announce(status, 'Nothing was added because the cart could not be verified. Please try again.');
      return {complete: false, verificationFailed: false};
    }

    const existing = readPending(key);
    if (existing && existing.completed) {
      announce(status, 'This cart update was already completed. Your cart was not changed again.');
      return {complete: true, verificationFailed: false};
    }
    const isRetry = Boolean(existing && existing.signature === signature);
    const pending = isRetry ? existing : createPending(key, signature, items, initialSnapshot);
    let snapshot = initialSnapshot;

    for (const item of pending.items) {
      const current = Number(snapshot.quantities[item.variantId] || 0);
      const target = Number(pending.targets[item.variantId] || 0);
      const missing = Math.max(0, target - current);
      if (!missing) continue;
      await postMissingQuantity(item, missing, parentForm, routes);
      try {
        snapshot = await cartSnapshot(routes);
      } catch (_) {
        announce(status, 'We could not verify the final cart state. Review your cart before trying again.');
        return {complete: false, verificationFailed: true};
      }
    }

    const remaining = remainingItems(pending, snapshot);
    if (!remaining.length) {
      writePending(key, {
        ...pending,
        completed: true,
        completedAt: Date.now(),
        expiresAt: Date.now() + COMPLETED_DEDUP_MS
      });
      announce(status, isRetry
        ? 'The retry added only the remaining items. Your cart is complete.'
        : 'The camera and selected additions were added to your cart.');
      return {complete: true, verificationFailed: false};
    }

    const remainingTitles = remaining.map((item) => item.title).join(', ');
    if (intendedAddedCount(pending, snapshot) === 0) {
      announce(status, `Nothing was added. Still needed: ${remainingTitles}. Please try again.`);
    } else {
      announce(status, `Some items are in your cart. Still not added: ${remainingTitles}. Retry here; items already added will not be duplicated.`);
    }
    writePending(key, {...pending, expiresAt: Date.now() + PENDING_TTL_MS});
    return {complete: false, verificationFailed: false};
  };

  function initialize(root) {
    if (root.dataset.cvAddonInitialized === 'true') return;
    root.dataset.cvAddonInitialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-cv-addon-card]'));
    const parentVariants = parseJSON(root.querySelector('[data-cv-parent-variants]'), []);
    const parentIds = new Set(parentVariants.map((variant) => String(variant.id)));
    const exactForm = document.getElementById(root.dataset.parentFormId || "");
    const parentForm = exactForm?.tagName === "FORM" && parentIds.has(String(exactForm.querySelector('[name="id"]')?.value)) ? exactForm : null;
    const status = root.querySelector('[data-cv-addon-status]');

    const currentParentId = () => {
      const inputValue = parentForm?.querySelector('[name="id"]')?.value;
      const urlValue = new URL(window.location.href).searchParams.get('variant');
      return String(inputValue || urlValue || root.dataset.currentParentVariantId || '');
    };

    const update = () => {
      const parentId = currentParentId();
      const parentVariant = parentVariants.find((variant) => String(variant.id) === parentId);
      let visibleCount = 0;
      cards.forEach((card) => {
        const applicable = parseList(card.dataset.applicableParentVariantIds);
        const mapping = parseMap(card.dataset.accessoryVariantMap);
        const variants = parseJSON(card.querySelector('[data-cv-addon-variants]'), []);
        const sku = mapping[parentId];
        const accessoryVariant = variants.find((variant) => variant.sku === sku);
        const checkbox = card.querySelector('[data-cv-addon-checkbox]');
        const quantity = card.querySelector('[data-cv-addon-quantity]');
        const quantityWrap = card.querySelector('[data-cv-addon-quantity-wrap]');
        const quantityNote = card.querySelector('[data-cv-addon-quantity-note]');
        const availability = card.querySelector('[data-cv-addon-availability]');
        const isApplicable = Boolean(parentVariant) && applicable.includes(parentId) && Boolean(accessoryVariant);
        card.hidden = !isApplicable;
        if (!isApplicable) {
          checkbox.checked = false;
          checkbox.disabled = true;
          return;
        }
        visibleCount += 1;
        checkbox.value = String(accessoryVariant.id);
        checkbox.disabled = !accessoryVariant.available;
        if (!accessoryVariant.available) checkbox.checked = false;
        card.querySelector('[data-cv-addon-price]').textContent = money(accessoryVariant.price);
        availability.textContent = accessoryVariant.available ? 'Available' : 'Currently unavailable';

        const logic = card.dataset.quantityLogic;
        if (logic === 'USER_SELECTABLE') {
          quantityWrap.hidden = false;
          quantity.readOnly = false;
          quantityNote.textContent = '';
        } else {
          const nextQuantity = logic === 'PER_CAMERA' ? cameraCount(parentVariant) * asPositiveInteger(parentForm?.querySelector('[name="quantity"]')?.value) : 1;
          quantity.value = String(nextQuantity);
          quantity.readOnly = true;
          quantityWrap.hidden = false;
          quantityNote.textContent = logic === 'PER_CAMERA' ? ` Matches the selected quantity of ${nextQuantity} camera(s).` : ' Fixed at one.';
          const maximum = Number.parseInt(quantity.getAttribute('max') || '', 10);
          if (Number.isFinite(maximum) && nextQuantity > maximum) {
            checkbox.checked = false;
            checkbox.disabled = true;
            availability.textContent = `Only ${maximum} can be ordered at this quantity. Contact ClearVero for a larger installation.`;
          }
        }
      });
      root.hidden = visibleCount === 0;
      root.dataset.currentParentVariantId = parentId;
    };

    update();
    document.addEventListener('change', () => window.requestAnimationFrame(update));
    document.addEventListener('variant:change', () => window.requestAnimationFrame(update));
    window.addEventListener('popstate', update);

    if (!parentForm || parentForm.dataset.cvAddonCartBound === 'true') return;
    parentForm.dataset.cvAddonCartBound = 'true';
    window.addEventListener('submit', async (event) => {
      if (event.target !== parentForm) return;
      const selected = cards.filter((card) => !card.hidden && card.querySelector('[data-cv-addon-checkbox]')?.checked);
      if (!selected.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (parentForm.dataset.cvAddonCartInFlight === 'true') {
        announce(status, 'Your cart update is already in progress.');
        return;
      }
      parentForm.dataset.cvAddonCartInFlight = 'true';

      let routes;
      try { routes = cartRoutes(parentForm); } catch (_) {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        announce(status, 'Nothing was added because the cart route could not be verified. Please refresh the page and try again.');
        return;
      }
      const parentId = currentParentId();
      const parentQuantity = asPositiveInteger(parentForm.querySelector('[name="quantity"]')?.value);
      const items = [{
        variantId: parentId,
        quantity: parentQuantity,
        title: 'Camera',
        role: 'parent'
      }];
      selected.forEach((card) => {
        items.push({
          variantId: String(card.querySelector('[data-cv-addon-checkbox]').value),
          quantity: asPositiveInteger(card.querySelector('[data-cv-addon-quantity]')?.value),
          title: card.dataset.accessoryTitle || 'Selected addition',
          role: 'accessory', once: card.dataset.quantityLogic === 'ONCE_PER_INSTALLATION'
        });
      });

      const buttons = Array.from(parentForm.querySelectorAll('[type="submit"]'));
      buttons.forEach((button) => { button.disabled = true; });
      announce(status, 'Checking your cart and adding only missing items…');
      let keepDisabled = false;
      let navigating = false;
      const action = async () => {
        const result = await runReconciledAdd({items, parentForm, status, routes});
        keepDisabled = result.verificationFailed;
        if (result.complete) {
          await window.CvFunnelTrack?.('cv_bundle_add', {parent_product_id: root.dataset.parentProductId, accessory_variant_ids: items.filter(i => i.role !== 'parent').map(i => i.variantId)});
          navigating = true;
          window.location.assign(routes.page);
        }
      };

      try {
        const lockName = `cv-addon-cart:${makeSignature(items)}`;
        if (navigator.locks && navigator.locks.request) {
          await navigator.locks.request(lockName, action);
        } else {
          await action();
        }
      } finally {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        if (!navigating && !keepDisabled) buttons.forEach((button) => { button.disabled = false; });
      }
    }, true);
  }

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-cv-z53-addon-section]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll()); else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-z53-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-cv-e10-s4-controller]';
  const controllers = new WeakMap();

  class CVE10S4Purchase {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.variants = this.readJson('[data-cv-e10-s4-variants]');
      this.gallery = this.readJson('[data-cv-e10-s4-gallery]');
      this.optionGroups = [...root.querySelectorAll('[data-cv-e10-s4-option]')];
      this.form = root.querySelector('[data-cv-e10-s4-product-form]');
      this.variantInput = root.querySelector('[data-cv-e10-s4-variant-input]');
      this.quantityInput = root.querySelector('[data-cv-e10-s4-quantity]');
      this.heroImage = root.querySelector('[data-cv-e10-s4-hero-image]');
      this.mobileSource = root.querySelector('[data-cv-e10-s4-mobile-source]');
      this.addButton = root.querySelector('[data-cv-e10-s4-add]');
      this.dialog = root.querySelector('[data-cv-e10-s4-dialog]');
      this.dialogImage = root.querySelector('[data-cv-e10-s4-gallery-image]');
      this.dialogCaption = root.querySelector('[data-cv-e10-s4-gallery-caption]');
      this.liveRegion = root.querySelector('[data-cv-e10-s4-live]');
      this.returnFocus = null;
      this.galleryIndex = 0;

      if (!this.form || !this.variantInput || !this.variants.length) return;
      this.bind();
      this.bindLoadingState();
      this.restoreFromUrl(false);
    }

    readJson(query) {
      const node = this.root.querySelector(query);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (_) {
        return [];
      }
    }

    bind() {
      const signal = this.abort.signal;

      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cv-e10-s4-option] input')) {
          this.update(this.findByOptions(), { historyMode: 'push', announce: true });
        }
        if (event.target.matches('[data-cv-e10-s4-quantity]')) this.normalizeQuantity();
      }, { signal });

      this.root.addEventListener('keydown', (event) => {
        const activationKeys = ['Enter', ' ', 'Spacebar'];
        if (!activationKeys.includes(event.key)) return;

        const addButton = event.target.closest('[data-cv-e10-s4-add]');
        if (addButton && this.form) {
          event.preventDefault();
          event.stopPropagation();
          this.submitNativeFallback(this.form, addButton);
          return;
        }

        if (event.target.closest('[data-cv-e10-s4-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }

        if (event.target.closest('[data-cv-e10-s4-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }

        const galleryTrigger = event.target.closest('[data-cv-e10-s4-gallery-open]');
        if (!galleryTrigger) return;

        event.preventDefault();
        this.openGallery(galleryTrigger);
      }, { signal, capture: true });

      this.root.addEventListener('click', (event) => {
        if (event.target.closest('[data-cv-e10-s4-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }
        if (event.target.closest('[data-cv-e10-s4-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }
        const galleryTrigger = event.target.closest('[data-cv-e10-s4-gallery-open]');
        if (galleryTrigger) {
          event.preventDefault();
          this.openGallery(galleryTrigger);
          return;
        }
        if (event.target.closest('[data-cv-e10-s4-gallery-close]')) this.closeGallery();
        if (event.target.closest('[data-cv-e10-s4-gallery-previous]')) this.showGallery(this.galleryIndex - 1);
        if (event.target.closest('[data-cv-e10-s4-gallery-next]')) this.showGallery(this.galleryIndex + 1);
      }, { signal });

      window.addEventListener('popstate', () => this.restoreFromUrl(false), { signal });

      if (this.dialog) {
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeGallery();
            return;
          }

          if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
            if (event.target.closest('[data-cv-e10-s4-gallery-close]')) {
              event.preventDefault();
              this.closeGallery();
              return;
            }
            if (event.target.closest('[data-cv-e10-s4-gallery-previous]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex - 1);
              return;
            }
            if (event.target.closest('[data-cv-e10-s4-gallery-next]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex + 1);
              return;
            }
          }

          if (event.key === 'ArrowLeft') this.showGallery(this.galleryIndex - 1);
          if (event.key === 'ArrowRight') this.showGallery(this.galleryIndex + 1);
          if (event.key === 'Tab') this.trapFocus(event);
        }, { signal });

        this.dialog.addEventListener('close', () => {
          this.dialogImage?.removeAttribute('src');
          document.documentElement.classList.remove('cv-e10-s4-dialog-open');
          this.returnFocus?.focus();
          this.returnFocus = null;
        }, { signal });
      }
    }

    bindLoadingState() {
      if (!this.addButton) return;
      const sync = () => {
        this.addButton = this.root.querySelector('[data-cv-e10-s4-add]');
        if (!this.addButton) return;

        const busy = this.addButton.hasAttribute('data-added');
        this.addButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.addButton.disabled = !this.currentVariant?.available;

        clearTimeout(this.loadingFallback);
        if (busy) this.loadingFallback = setTimeout(() => this.settleLoadingState(), 3000);
      };

      this.loadingObserver = new MutationObserver(sync);
      this.loadingObserver.observe(this.root, {
        attributes: true,
        attributeFilter: ['data-added'],
        childList: true,
        subtree: true,
      });

      const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
      if (errorRegion) {
        this.errorObserver = new MutationObserver(() => {
          if (errorRegion.textContent.trim()) this.settleLoadingState();
        });
        this.errorObserver.observe(errorRegion, { childList: true, characterData: true, subtree: true });
      }

      sync();
    }

    settleLoadingState() {
      clearTimeout(this.loadingFallback);
      this.addButton = this.root.querySelector('[data-cv-e10-s4-add]');
      if (!this.addButton) return;

      this.addButton.removeAttribute('data-added');
      this.addButton.classList.remove('loading');
      this.addButton.setAttribute('aria-busy', 'false');
      this.addButton.disabled = !this.currentVariant?.available;
    }

    async submitNativeFallback(form, submitter) {
      if (form.dataset.cvE10S4FallbackSubmitting === 'true') return;

      form.dataset.cvE10S4FallbackSubmitting = 'true';
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin',
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add this item to the cart.');
        }

        window.location.assign(Theme.routes.cart_url || '/cart');
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Unable to add this item to the cart.';
        const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
        if (errorRegion) errorRegion.textContent = message;
        if (this.liveRegion) this.liveRegion.textContent = message;
        form.removeAttribute('data-cv-e10-s4-fallback-submitting');
        if (submitter) {
          submitter.removeAttribute('aria-busy');
          submitter.disabled = !this.currentVariant?.available;
        }
      }
    }

    selectedOptions() {
      return this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    }

    findByOptions() {
      const options = this.selectedOptions();
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    findById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id));
    }

    restoreFromUrl(announce) {
      const id = new URL(window.location.href).searchParams.get('variant') || this.variantInput.value;
      const variant = this.findById(id) || this.findByOptions() || this.variants[0];
      this.checkOptions(variant);
      this.update(variant, { historyMode: 'replace', announce });
    }

    checkOptions(variant) {
      if (!variant) return;
      this.optionGroups.forEach((group, index) => {
        const input = [...group.querySelectorAll('input')].find((node) => node.value === variant.options[index]);
        if (input) input.checked = true;
      });
    }

    update(variant, { historyMode = 'replace', announce = false } = {}) {
      if (!variant) return;
      this.currentVariant = variant;

      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      this.optionGroups.forEach((group) => {
        const output = group.querySelector('[data-cv-e10-s4-option-value]');
        const checked = group.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });

      this.setText('[data-cv-e10-s4-price]', variant.priceFormatted);
      this.setText('[data-cv-e10-s4-sku]', variant.sku || '—');

      const compare = this.root.querySelector('[data-cv-e10-s4-compare]');
      if (compare) {
        compare.hidden = !(variant.compareAt > variant.price);
        compare.textContent = variant.compareAt > variant.price ? variant.compareAtFormatted : '';
      }

      const addButton = this.root.querySelector('[data-cv-e10-s4-add]');
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        const label = addButton.querySelector('[data-cv-e10-s4-add-label]');
        if (label) label.textContent = variant.available ? addButton.dataset.readyLabel : addButton.dataset.unavailableLabel;
      }

      this.updateQuantityRules(variant);
      this.updateHero(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      const state = { ...window.history.state, variantId: variant.id };
      if (historyMode === 'push') window.history.pushState(state, '', url);
      else window.history.replaceState(state, '', url);

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = `${variant.title}. ${variant.priceFormatted}. ${variant.available ? 'Available' : 'Unavailable'}.`;
      }

      window.dispatchEvent(new CustomEvent('cv-e10-s4:variant-change', {
        detail: { productId: this.root.dataset.productId, variant },
      }));
    }

    updateQuantityRules(variant) {
      if (!this.quantityInput) return;
      const minimum = Number(variant.quantityMin) || 1;
      const increment = Number(variant.quantityIncrement) || 1;
      this.quantityInput.min = String(minimum);
      this.quantityInput.step = String(increment);
      if (variant.quantityMax == null) this.quantityInput.removeAttribute('max');
      else this.quantityInput.max = String(variant.quantityMax);
      this.normalizeQuantity();
    }

    normalizeQuantity() {
      if (!this.quantityInput) return;
      const minimum = Number(this.quantityInput.min) || 1;
      const maximum = this.quantityInput.max ? Number(this.quantityInput.max) : Infinity;
      const increment = Number(this.quantityInput.step) || 1;
      const raw = Number.parseInt(this.quantityInput.value, 10);
      const safe = Number.isFinite(raw) ? raw : minimum;
      const stepped = minimum + Math.round((safe - minimum) / increment) * increment;
      this.quantityInput.value = String(Math.min(maximum, Math.max(minimum, stepped)));
      const minus = this.root.querySelector('[data-cv-e10-s4-quantity-minus]');
      const plus = this.root.querySelector('[data-cv-e10-s4-quantity-plus]');
      if (minus) minus.disabled = Number(this.quantityInput.value) <= minimum;
      if (plus) plus.disabled = Number(this.quantityInput.value) >= maximum;
    }

    stepQuantity(direction) {
      if (!this.quantityInput) return;
      const increment = Number(this.quantityInput.step) || 1;
      const current = Number.parseInt(this.quantityInput.value, 10) || Number(this.quantityInput.min) || 1;
      this.quantityInput.value = String(current + direction * increment);
      this.normalizeQuantity();
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateHero(variant) {
      if (!this.heroImage || !variant.image) return;
      this.heroImage.src = variant.image;
      if (variant.srcset) this.heroImage.srcset = variant.srcset;
      else this.heroImage.removeAttribute('srcset');
      this.heroImage.alt = variant.alt || '';
      if (this.mobileSource && !this.mobileSource.srcset) this.mobileSource.removeAttribute('srcset');
    }

    setText(selector, value) {
      const node = this.root.querySelector(selector);
      if (node) node.textContent = value ?? '';
    }

    openGallery(trigger) {
      if (!this.dialog || !this.gallery.length) return;
      this.returnFocus = trigger;
      this.showGallery(0);
      this.dialog.showModal();
      document.documentElement.classList.add('cv-e10-s4-dialog-open');
      this.dialog.querySelector('[data-cv-e10-s4-gallery-close]')?.focus();
    }

    showGallery(index) {
      if (!this.gallery.length || !this.dialogImage) return;
      this.galleryIndex = (index + this.gallery.length) % this.gallery.length;
      const item = this.gallery[this.galleryIndex];
      this.dialogImage.src = item.src;
      this.dialogImage.alt = item.alt || '';
      if (this.dialogCaption) {
        this.dialogCaption.textContent = item.caption || '';
        this.dialogCaption.hidden = !item.caption;
      }
      const position = this.dialog.querySelector('[data-cv-e10-s4-gallery-position]');
      if (position) position.textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
    }

    trapFocus(event) {
      const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((node) => !node.hidden && node.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeGallery() {
      if (this.dialog?.open) this.dialog.close();
    }

    destroy() {
      this.abort.abort();
      this.loadingObserver?.disconnect();
      this.errorObserver?.disconnect();
      clearTimeout(this.loadingFallback);
    }
  }

  const initialize = (scope = document) => {
    const roots = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    roots.forEach((root) => {
      if (controllers.has(root)) return;
      controllers.set(root, new CVE10S4Purchase(root));
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    if (!root) return;
    controllers.get(root)?.destroy();
    controllers.delete(root);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-z911-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const PENDING_VERSION = 1;
  const PENDING_TTL_MS = 30 * 60 * 1000;
  const COMPLETED_DEDUP_MS = 10 * 1000;
  const memoryPending = new Map();

  const parseList = (value) => (value || '').split('|').map((item) => item.trim()).filter(Boolean);
  const parseMap = (value) => {
    const result = {};
    parseList(value).forEach((pair) => {
      const separator = pair.indexOf('=>');
      if (separator > 0) result[pair.slice(0, separator).trim()] = pair.slice(separator + 2).trim();
    });
    return result;
  };
  const parseJSON = (element, fallback) => {
    try { return JSON.parse(element ? element.textContent : ''); } catch (_) { return fallback; }
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: 'USD'}).format(Number(cents || 0) / 100);
  const cameraCount = (variant) => Math.max(1, Number(variant?.cameraCount || 1));
  const asPositiveInteger = (value) => Math.max(1, Number.parseInt(value || '1', 10) || 1);
  const pendingKey = (signature) => `cv-addon-pending:v${PENDING_VERSION}:${signature}`;

  const readPending = (key) => {
    let value = memoryPending.get(key) || null;
    try { value = window.localStorage.getItem(key) || value; } catch (_) {}
    if (!value) return null;
    try {
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      if (parsed.version !== PENDING_VERSION || parsed.expiresAt <= Date.now()) {
        clearPending(key);
        return null;
      }
      return parsed;
    } catch (_) {
      clearPending(key);
      return null;
    }
  };

  const writePending = (key, value) => {
    memoryPending.set(key, value);
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };

  const clearPending = (key) => {
    memoryPending.delete(key);
    try { window.localStorage.removeItem(key); } catch (_) {}
  };

  const cartRoutes = (form) => {
    const action = new URL(form.getAttribute('action') || '/cart/add', window.location.href);
    const pathname = action.pathname.endsWith('/') ? action.pathname.slice(0, -1) : action.pathname;
    const suffix = pathname.endsWith('/cart/add.js') ? '/add.js' : pathname.endsWith('/cart/add') ? '/add' : null;
    if (action.origin !== window.location.origin || !suffix) throw new Error('CART_ROUTE_UNVERIFIED');
    const base = pathname.slice(0, -suffix.length);
    const route = (suffix) => {
      const target = new URL(action.href);
      target.pathname = base + suffix;
      return target.pathname + target.search;
    };
    return {read: route('.js'), add: route('/add.js'), page: route('')};
  };

  const cartSnapshot = async (routes) => {
    const response = await fetch(routes.read, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('CART_READ_FAILED');
    const cart = await response.json();
    const quantities = {};
    (cart.items || []).forEach((item) => {
      const id = String(item.variant_id || item.id || '');
      if (id) quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });
    return {cart, quantities};
  };

  const makeSignature = (items) => items
    .map((item) => `${item.variantId}:${item.quantity}`)
    .sort()
    .join('|');

  const announce = (status, message) => {
    if (status) status.textContent = message;
  };

  const createPending = (key, signature, items, snapshot) => {
    const requested = {};
    items.forEach((item) => {
      requested[item.variantId] = (requested[item.variantId] || 0) + item.quantity;
    });
    const targets = {};
    Object.entries(requested).forEach(([variantId, quantity]) => {
      targets[variantId] = Number(snapshot.quantities[variantId] || 0) + quantity;
    });
    const pending = {
      version: PENDING_VERSION,
      signature,
      createdAt: Date.now(),
      expiresAt: Date.now() + PENDING_TTL_MS,
      baseline: snapshot.quantities,
      targets,
      items
    };
    writePending(key, pending);
    return pending;
  };

  const remainingItems = (pending, snapshot) => pending.items.filter((item, index, all) => (
    all.findIndex((candidate) => candidate.variantId === item.variantId) === index
    && Number(snapshot.quantities[item.variantId] || 0) < Number(pending.targets[item.variantId] || 0)
  ));

  const intendedAddedCount = (pending, snapshot) => Object.keys(pending.targets).reduce((total, variantId) => {
    const baseline = Number(pending.baseline[variantId] || 0);
    const target = Number(pending.targets[variantId] || 0);
    const current = Number(snapshot.quantities[variantId] || 0);
    return total + Math.max(0, Math.min(target, current) - baseline);
  }, 0);

  const postMissingQuantity = async (item, quantity, parentForm, routes) => {
    let body;
    let headers = {Accept: 'application/json'};
    if (item.role === 'parent') {
      body = new FormData(parentForm);
      body.set('id', item.variantId);
      body.set('quantity', String(quantity));
    } else {
      body = new URLSearchParams({id: item.variantId, quantity: String(quantity)});
      headers = {...headers, 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'};
    }
    try {
      await fetch(routes.add, {method: 'POST', body, headers});
    } catch (_) {
      // The response cannot be trusted as proof of cart state. The caller reads /cart.js next.
    }
  };

  const runReconciledAdd = async ({items, parentForm, status, routes}) => {
    const signature = makeSignature(items);
    const key = pendingKey(routes.read + ':' + signature);
    let initialSnapshot;
    try {
      initialSnapshot = await cartSnapshot(routes);
    } catch (_) {
      announce(status, 'Nothing was added because the cart could not be verified. Please try again.');
      return {complete: false, verificationFailed: false};
    }

    const existing = readPending(key);
    if (existing && existing.completed) {
      announce(status, 'This cart update was already completed. Your cart was not changed again.');
      return {complete: true, verificationFailed: false};
    }
    const isRetry = Boolean(existing && existing.signature === signature);
    const pending = isRetry ? existing : createPending(key, signature, items, initialSnapshot);
    let snapshot = initialSnapshot;

    for (const item of pending.items) {
      const current = Number(snapshot.quantities[item.variantId] || 0);
      const target = Number(pending.targets[item.variantId] || 0);
      const missing = Math.max(0, target - current);
      if (!missing) continue;
      await postMissingQuantity(item, missing, parentForm, routes);
      try {
        snapshot = await cartSnapshot(routes);
      } catch (_) {
        announce(status, 'We could not verify the final cart state. Review your cart before trying again.');
        return {complete: false, verificationFailed: true};
      }
    }

    const remaining = remainingItems(pending, snapshot);
    if (!remaining.length) {
      writePending(key, {
        ...pending,
        completed: true,
        completedAt: Date.now(),
        expiresAt: Date.now() + COMPLETED_DEDUP_MS
      });
      announce(status, isRetry
        ? 'The retry added only the remaining items. Your cart is complete.'
        : 'The camera and selected additions were added to your cart.');
      return {complete: true, verificationFailed: false};
    }

    const remainingTitles = remaining.map((item) => item.title).join(', ');
    if (intendedAddedCount(pending, snapshot) === 0) {
      announce(status, `Nothing was added. Still needed: ${remainingTitles}. Please try again.`);
    } else {
      announce(status, `Some items are in your cart. Still not added: ${remainingTitles}. Retry here; items already added will not be duplicated.`);
    }
    writePending(key, {...pending, expiresAt: Date.now() + PENDING_TTL_MS});
    return {complete: false, verificationFailed: false};
  };

  function initialize(root) {
    if (root.dataset.cvAddonInitialized === 'true') return;
    root.dataset.cvAddonInitialized = 'true';
    const cards = Array.from(root.querySelectorAll('[data-cv-addon-card]'));
    const parentVariants = parseJSON(root.querySelector('[data-cv-parent-variants]'), []);
    const parentIds = new Set(parentVariants.map((variant) => String(variant.id)));
    const exactForm = document.getElementById(root.dataset.parentFormId || "");
    const parentForm = exactForm?.tagName === "FORM" && parentIds.has(String(exactForm.querySelector('[name="id"]')?.value)) ? exactForm : null;
    const status = root.querySelector('[data-cv-addon-status]');

    const currentParentId = () => {
      const inputValue = parentForm?.querySelector('[name="id"]')?.value;
      const urlValue = new URL(window.location.href).searchParams.get('variant');
      return String(inputValue || urlValue || root.dataset.currentParentVariantId || '');
    };

    const update = () => {
      const parentId = currentParentId();
      const parentVariant = parentVariants.find((variant) => String(variant.id) === parentId);
      let visibleCount = 0;
      cards.forEach((card) => {
        const applicable = parseList(card.dataset.applicableParentVariantIds);
        const mapping = parseMap(card.dataset.accessoryVariantMap);
        const variants = parseJSON(card.querySelector('[data-cv-addon-variants]'), []);
        const sku = mapping[parentId];
        const accessoryVariant = variants.find((variant) => variant.sku === sku);
        const checkbox = card.querySelector('[data-cv-addon-checkbox]');
        const quantity = card.querySelector('[data-cv-addon-quantity]');
        const quantityWrap = card.querySelector('[data-cv-addon-quantity-wrap]');
        const quantityNote = card.querySelector('[data-cv-addon-quantity-note]');
        const availability = card.querySelector('[data-cv-addon-availability]');
        const isApplicable = Boolean(parentVariant) && applicable.includes(parentId) && Boolean(accessoryVariant);
        card.hidden = !isApplicable;
        if (!isApplicable) {
          checkbox.checked = false;
          checkbox.disabled = true;
          return;
        }
        visibleCount += 1;
        checkbox.value = String(accessoryVariant.id);
        checkbox.disabled = !accessoryVariant.available;
        if (!accessoryVariant.available) checkbox.checked = false;
        card.querySelector('[data-cv-addon-price]').textContent = money(accessoryVariant.price);
        availability.textContent = accessoryVariant.available ? 'Available' : 'Currently unavailable';

        const logic = card.dataset.quantityLogic;
        if (logic === 'USER_SELECTABLE') {
          quantityWrap.hidden = false;
          quantity.readOnly = false;
          quantityNote.textContent = '';
        } else {
          const nextQuantity = logic === 'PER_CAMERA' ? cameraCount(parentVariant) * asPositiveInteger(parentForm?.querySelector('[name="quantity"]')?.value) : 1;
          quantity.value = String(nextQuantity);
          quantity.readOnly = true;
          quantityWrap.hidden = false;
          quantityNote.textContent = logic === 'PER_CAMERA' ? ` Matches the selected quantity of ${nextQuantity} camera(s).` : ' Fixed at one.';
          const maximum = Number.parseInt(quantity.getAttribute('max') || '', 10);
          if (Number.isFinite(maximum) && nextQuantity > maximum) {
            checkbox.checked = false;
            checkbox.disabled = true;
            availability.textContent = `Only ${maximum} can be ordered at this quantity. Contact ClearVero for a larger installation.`;
          }
        }
      });
      root.hidden = visibleCount === 0;
      root.dataset.currentParentVariantId = parentId;
    };

    update();
    document.addEventListener('change', () => window.requestAnimationFrame(update));
    document.addEventListener('variant:change', () => window.requestAnimationFrame(update));
    window.addEventListener('popstate', update);

    if (!parentForm || parentForm.dataset.cvAddonCartBound === 'true') return;
    parentForm.dataset.cvAddonCartBound = 'true';
    window.addEventListener('submit', async (event) => {
      if (event.target !== parentForm) return;
      const selected = cards.filter((card) => !card.hidden && card.querySelector('[data-cv-addon-checkbox]')?.checked);
      if (!selected.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (parentForm.dataset.cvAddonCartInFlight === 'true') {
        announce(status, 'Your cart update is already in progress.');
        return;
      }
      parentForm.dataset.cvAddonCartInFlight = 'true';

      let routes;
      try { routes = cartRoutes(parentForm); } catch (_) {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        announce(status, 'Nothing was added because the cart route could not be verified. Please refresh the page and try again.');
        return;
      }
      const parentId = currentParentId();
      const parentQuantity = asPositiveInteger(parentForm.querySelector('[name="quantity"]')?.value);
      const items = [{
        variantId: parentId,
        quantity: parentQuantity,
        title: 'Camera',
        role: 'parent'
      }];
      selected.forEach((card) => {
        items.push({
          variantId: String(card.querySelector('[data-cv-addon-checkbox]').value),
          quantity: asPositiveInteger(card.querySelector('[data-cv-addon-quantity]')?.value),
          title: card.dataset.accessoryTitle || 'Selected addition',
          role: 'accessory'
        });
      });

      const buttons = Array.from(parentForm.querySelectorAll('[type="submit"]'));
      buttons.forEach((button) => { button.disabled = true; });
      announce(status, 'Checking your cart and adding only missing items…');
      let keepDisabled = false;
      let navigating = false;
      const action = async () => {
        const result = await runReconciledAdd({items, parentForm, status, routes});
        keepDisabled = result.verificationFailed;
        if (result.complete) {
          navigating = true;
          window.location.assign(routes.page);
        }
      };

      try {
        const lockName = `cv-addon-cart:${makeSignature(items)}`;
        if (navigator.locks && navigator.locks.request) {
          await navigator.locks.request(lockName, action);
        } else {
          await action();
        }
      } finally {
        parentForm.dataset.cvAddonCartInFlight = 'false';
        if (!navigating && !keepDisabled) buttons.forEach((button) => { button.disabled = false; });
      }
    }, true);
  }

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-cv-z911-addon-section]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll()); else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-acti-z911-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-cv-e10-s4-controller]';
  const controllers = new WeakMap();

  class CVE10S4Purchase {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.variants = this.readJson('[data-cv-e10-s4-variants]');
      this.gallery = this.readJson('[data-cv-e10-s4-gallery]');
      this.optionGroups = [...root.querySelectorAll('[data-cv-e10-s4-option]')];
      this.form = root.querySelector('[data-cv-e10-s4-product-form]');
      this.variantInput = root.querySelector('[data-cv-e10-s4-variant-input]');
      this.quantityInput = root.querySelector('[data-cv-e10-s4-quantity]');
      this.heroImage = root.querySelector('[data-cv-e10-s4-hero-image]');
      this.mobileSource = root.querySelector('[data-cv-e10-s4-mobile-source]');
      this.addButton = root.querySelector('[data-cv-e10-s4-add]');
      this.dialog = root.querySelector('[data-cv-e10-s4-dialog]');
      this.dialogImage = root.querySelector('[data-cv-e10-s4-gallery-image]');
      this.dialogCaption = root.querySelector('[data-cv-e10-s4-gallery-caption]');
      this.liveRegion = root.querySelector('[data-cv-e10-s4-live]');
      this.returnFocus = null;
      this.galleryIndex = 0;

      if (!this.form || !this.variantInput || !this.variants.length) return;
      this.bind();
      this.bindLoadingState();
      this.restoreFromUrl(false);
    }

    readJson(query) {
      const node = this.root.querySelector(query);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (_) {
        return [];
      }
    }

    bind() {
      const signal = this.abort.signal;

      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cv-e10-s4-option] input')) {
          this.update(this.findByOptions(), { historyMode: 'push', announce: true });
        }
        if (event.target.matches('[data-cv-e10-s4-quantity]')) this.normalizeQuantity();
      }, { signal });

      this.root.addEventListener('keydown', (event) => {
        const activationKeys = ['Enter', ' ', 'Spacebar'];
        if (!activationKeys.includes(event.key)) return;

        const addButton = event.target.closest('[data-cv-e10-s4-add]');
        if (addButton && this.form) {
          event.preventDefault();
          event.stopPropagation();
          this.submitNativeFallback(this.form, addButton);
          return;
        }

        if (event.target.closest('[data-cv-e10-s4-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }

        if (event.target.closest('[data-cv-e10-s4-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }

        const galleryTrigger = event.target.closest('[data-cv-e10-s4-gallery-open]');
        if (!galleryTrigger) return;

        event.preventDefault();
        this.openGallery(galleryTrigger);
      }, { signal, capture: true });

      this.root.addEventListener('click', (event) => {
        if (event.target.closest('[data-cv-e10-s4-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }
        if (event.target.closest('[data-cv-e10-s4-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }
        const galleryTrigger = event.target.closest('[data-cv-e10-s4-gallery-open]');
        if (galleryTrigger) {
          event.preventDefault();
          this.openGallery(galleryTrigger);
          return;
        }
        if (event.target.closest('[data-cv-e10-s4-gallery-close]')) this.closeGallery();
        if (event.target.closest('[data-cv-e10-s4-gallery-previous]')) this.showGallery(this.galleryIndex - 1);
        if (event.target.closest('[data-cv-e10-s4-gallery-next]')) this.showGallery(this.galleryIndex + 1);
      }, { signal });

      window.addEventListener('popstate', () => this.restoreFromUrl(false), { signal });

      if (this.dialog) {
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeGallery();
            return;
          }

          if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
            if (event.target.closest('[data-cv-e10-s4-gallery-close]')) {
              event.preventDefault();
              this.closeGallery();
              return;
            }
            if (event.target.closest('[data-cv-e10-s4-gallery-previous]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex - 1);
              return;
            }
            if (event.target.closest('[data-cv-e10-s4-gallery-next]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex + 1);
              return;
            }
          }

          if (event.key === 'ArrowLeft') this.showGallery(this.galleryIndex - 1);
          if (event.key === 'ArrowRight') this.showGallery(this.galleryIndex + 1);
          if (event.key === 'Tab') this.trapFocus(event);
        }, { signal });

        this.dialog.addEventListener('close', () => {
          this.dialogImage?.removeAttribute('src');
          document.documentElement.classList.remove('cv-e10-s4-dialog-open');
          this.returnFocus?.focus();
          this.returnFocus = null;
        }, { signal });
      }
    }

    bindLoadingState() {
      if (!this.addButton) return;
      const sync = () => {
        this.addButton = this.root.querySelector('[data-cv-e10-s4-add]');
        if (!this.addButton) return;

        const busy = this.addButton.hasAttribute('data-added');
        this.addButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.addButton.disabled = !this.currentVariant?.available;

        clearTimeout(this.loadingFallback);
        if (busy) this.loadingFallback = setTimeout(() => this.settleLoadingState(), 3000);
      };

      this.loadingObserver = new MutationObserver(sync);
      this.loadingObserver.observe(this.root, {
        attributes: true,
        attributeFilter: ['data-added'],
        childList: true,
        subtree: true,
      });

      const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
      if (errorRegion) {
        this.errorObserver = new MutationObserver(() => {
          if (errorRegion.textContent.trim()) this.settleLoadingState();
        });
        this.errorObserver.observe(errorRegion, { childList: true, characterData: true, subtree: true });
      }

      sync();
    }

    settleLoadingState() {
      clearTimeout(this.loadingFallback);
      this.addButton = this.root.querySelector('[data-cv-e10-s4-add]');
      if (!this.addButton) return;

      this.addButton.removeAttribute('data-added');
      this.addButton.classList.remove('loading');
      this.addButton.setAttribute('aria-busy', 'false');
      this.addButton.disabled = !this.currentVariant?.available;
    }

    async submitNativeFallback(form, submitter) {
      if (form.dataset.cvE10S4FallbackSubmitting === 'true') return;

      form.dataset.cvE10S4FallbackSubmitting = 'true';
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin',
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add this item to the cart.');
        }

        window.location.assign(Theme.routes.cart_url || '/cart');
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Unable to add this item to the cart.';
        const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
        if (errorRegion) errorRegion.textContent = message;
        if (this.liveRegion) this.liveRegion.textContent = message;
        form.removeAttribute('data-cv-e10-s4-fallback-submitting');
        if (submitter) {
          submitter.removeAttribute('aria-busy');
          submitter.disabled = !this.currentVariant?.available;
        }
      }
    }

    selectedOptions() {
      return this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    }

    findByOptions() {
      const options = this.selectedOptions();
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    findById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id));
    }

    restoreFromUrl(announce) {
      const id = new URL(window.location.href).searchParams.get('variant') || this.variantInput.value;
      const variant = this.findById(id) || this.findByOptions() || this.variants[0];
      this.checkOptions(variant);
      this.update(variant, { historyMode: 'replace', announce });
    }

    checkOptions(variant) {
      if (!variant) return;
      this.optionGroups.forEach((group, index) => {
        const input = [...group.querySelectorAll('input')].find((node) => node.value === variant.options[index]);
        if (input) input.checked = true;
      });
    }

    update(variant, { historyMode = 'replace', announce = false } = {}) {
      if (!variant) return;
      this.currentVariant = variant;

      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      this.optionGroups.forEach((group) => {
        const output = group.querySelector('[data-cv-e10-s4-option-value]');
        const checked = group.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });

      this.setText('[data-cv-e10-s4-price]', variant.priceFormatted);
      this.setText('[data-cv-e10-s4-sku]', variant.sku || '—');

      const compare = this.root.querySelector('[data-cv-e10-s4-compare]');
      if (compare) {
        compare.hidden = !(variant.compareAt > variant.price);
        compare.textContent = variant.compareAt > variant.price ? variant.compareAtFormatted : '';
      }

      const addButton = this.root.querySelector('[data-cv-e10-s4-add]');
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        const label = addButton.querySelector('[data-cv-e10-s4-add-label]');
        if (label) label.textContent = variant.available ? addButton.dataset.readyLabel : addButton.dataset.unavailableLabel;
      }

      this.updateQuantityRules(variant);
      this.updateHero(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      const state = { ...window.history.state, variantId: variant.id };
      if (historyMode === 'push') window.history.pushState(state, '', url);
      else window.history.replaceState(state, '', url);

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = `${variant.title}. ${variant.priceFormatted}. ${variant.available ? 'Available' : 'Unavailable'}.`;
      }

      window.dispatchEvent(new CustomEvent('cv-e10-s4:variant-change', {
        detail: { productId: this.root.dataset.productId, variant },
      }));
    }

    updateQuantityRules(variant) {
      if (!this.quantityInput) return;
      const minimum = Number(variant.quantityMin) || 1;
      const increment = Number(variant.quantityIncrement) || 1;
      this.quantityInput.min = String(minimum);
      this.quantityInput.step = String(increment);
      if (variant.quantityMax == null) this.quantityInput.removeAttribute('max');
      else this.quantityInput.max = String(variant.quantityMax);
      this.normalizeQuantity();
    }

    normalizeQuantity() {
      if (!this.quantityInput) return;
      const minimum = Number(this.quantityInput.min) || 1;
      const maximum = this.quantityInput.max ? Number(this.quantityInput.max) : Infinity;
      const increment = Number(this.quantityInput.step) || 1;
      const raw = Number.parseInt(this.quantityInput.value, 10);
      const safe = Number.isFinite(raw) ? raw : minimum;
      const stepped = minimum + Math.round((safe - minimum) / increment) * increment;
      this.quantityInput.value = String(Math.min(maximum, Math.max(minimum, stepped)));
      const minus = this.root.querySelector('[data-cv-e10-s4-quantity-minus]');
      const plus = this.root.querySelector('[data-cv-e10-s4-quantity-plus]');
      if (minus) minus.disabled = Number(this.quantityInput.value) <= minimum;
      if (plus) plus.disabled = Number(this.quantityInput.value) >= maximum;
    }

    stepQuantity(direction) {
      if (!this.quantityInput) return;
      const increment = Number(this.quantityInput.step) || 1;
      const current = Number.parseInt(this.quantityInput.value, 10) || Number(this.quantityInput.min) || 1;
      this.quantityInput.value = String(current + direction * increment);
      this.normalizeQuantity();
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateHero(variant) {
      if (!this.heroImage || !variant.image) return;
      this.heroImage.src = variant.image;
      if (variant.srcset) this.heroImage.srcset = variant.srcset;
      else this.heroImage.removeAttribute('srcset');
      this.heroImage.alt = variant.alt || '';
      if (this.mobileSource && !this.mobileSource.srcset) this.mobileSource.removeAttribute('srcset');
    }

    setText(selector, value) {
      const node = this.root.querySelector(selector);
      if (node) node.textContent = value ?? '';
    }

    openGallery(trigger) {
      if (!this.dialog || !this.gallery.length) return;
      this.returnFocus = trigger;
      this.showGallery(0);
      this.dialog.showModal();
      document.documentElement.classList.add('cv-e10-s4-dialog-open');
      this.dialog.querySelector('[data-cv-e10-s4-gallery-close]')?.focus();
    }

    showGallery(index) {
      if (!this.gallery.length || !this.dialogImage) return;
      this.galleryIndex = (index + this.gallery.length) % this.gallery.length;
      const item = this.gallery[this.galleryIndex];
      this.dialogImage.src = item.src;
      this.dialogImage.alt = item.alt || '';
      if (this.dialogCaption) {
        this.dialogCaption.textContent = item.caption || '';
        this.dialogCaption.hidden = !item.caption;
      }
      const position = this.dialog.querySelector('[data-cv-e10-s4-gallery-position]');
      if (position) position.textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
    }

    trapFocus(event) {
      const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((node) => !node.hidden && node.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeGallery() {
      if (this.dialog?.open) this.dialog.close();
    }

    destroy() {
      this.abort.abort();
      this.loadingObserver?.disconnect();
      this.errorObserver?.disconnect();
      clearTimeout(this.loadingFallback);
    }
  }

  const initialize = (scope = document) => {
    const roots = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    roots.forEach((root) => {
      if (controllers.has(root)) return;
      controllers.set(root, new CVE10S4Purchase(root));
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    if (!root) return;
    controllers.get(root)?.destroy();
    controllers.delete(root);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-eufy-s4-hbpro-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-cv-s4-hbpro-controller]';
  const controllers = new WeakMap();

  class CVS4HBPROPurchase {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.variants = this.readJson('[data-cv-s4-hbpro-variants]');
      this.gallery = this.readJson('[data-cv-s4-hbpro-gallery]');
      this.optionGroups = [...root.querySelectorAll('[data-cv-s4-hbpro-option]')];
      this.form = root.querySelector('[data-cv-s4-hbpro-product-form]');
      this.variantInput = root.querySelector('[data-cv-s4-hbpro-variant-input]');
      this.quantityInput = root.querySelector('[data-cv-s4-hbpro-quantity]');
      this.heroImage = root.querySelector('[data-cv-s4-hbpro-hero-image]');
      this.mobileSource = root.querySelector('[data-cv-s4-hbpro-mobile-source]');
      this.addButton = root.querySelector('[data-cv-s4-hbpro-add]');
      this.dialog = root.querySelector('[data-cv-s4-hbpro-dialog]');
      this.dialogImage = root.querySelector('[data-cv-s4-hbpro-gallery-image]');
      this.dialogCaption = root.querySelector('[data-cv-s4-hbpro-gallery-caption]');
      this.liveRegion = root.querySelector('[data-cv-s4-hbpro-live]');
      this.returnFocus = null;
      this.galleryIndex = 0;

      if (!this.form || !this.variantInput || !this.variants.length) return;
      this.bind();
      this.bindLoadingState();
      this.restoreFromUrl(false);
    }

    readJson(query) {
      const node = this.root.querySelector(query);
      if (!node) return [];
      try {
        return JSON.parse(node.textContent || '[]');
      } catch (_) {
        return [];
      }
    }

    bind() {
      const signal = this.abort.signal;

      this.root.addEventListener('change', (event) => {
        if (event.target.matches('[data-cv-s4-hbpro-option] input')) {
          this.update(this.findByOptions(), { historyMode: 'push', announce: true });
        }
        if (event.target.matches('[data-cv-s4-hbpro-quantity]')) this.normalizeQuantity();
      }, { signal });

      this.root.addEventListener('keydown', (event) => {
        const activationKeys = ['Enter', ' ', 'Spacebar'];
        if (!activationKeys.includes(event.key)) return;

        const addButton = event.target.closest('[data-cv-s4-hbpro-add]');
        if (addButton && this.form) {
          event.preventDefault();
          event.stopPropagation();
          this.submitNativeFallback(this.form, addButton);
          return;
        }

        if (event.target.closest('[data-cv-s4-hbpro-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }

        if (event.target.closest('[data-cv-s4-hbpro-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }

        const galleryTrigger = event.target.closest('[data-cv-s4-hbpro-gallery-open]');
        if (!galleryTrigger) return;

        event.preventDefault();
        this.openGallery(galleryTrigger);
      }, { signal, capture: true });

      this.root.addEventListener('click', (event) => {
        if (event.target.closest('[data-cv-s4-hbpro-quantity-minus]')) {
          event.preventDefault();
          this.stepQuantity(-1);
          return;
        }
        if (event.target.closest('[data-cv-s4-hbpro-quantity-plus]')) {
          event.preventDefault();
          this.stepQuantity(1);
          return;
        }
        const galleryTrigger = event.target.closest('[data-cv-s4-hbpro-gallery-open]');
        if (galleryTrigger) {
          event.preventDefault();
          this.openGallery(galleryTrigger);
          return;
        }
        if (event.target.closest('[data-cv-s4-hbpro-gallery-close]')) this.closeGallery();
        if (event.target.closest('[data-cv-s4-hbpro-gallery-previous]')) this.showGallery(this.galleryIndex - 1);
        if (event.target.closest('[data-cv-s4-hbpro-gallery-next]')) this.showGallery(this.galleryIndex + 1);
      }, { signal });

      window.addEventListener('popstate', () => this.restoreFromUrl(false), { signal });

      if (this.dialog) {
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeGallery();
        }, { signal });

        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeGallery();
            return;
          }

          if (['Enter', ' ', 'Spacebar'].includes(event.key)) {
            if (event.target.closest('[data-cv-s4-hbpro-gallery-close]')) {
              event.preventDefault();
              this.closeGallery();
              return;
            }
            if (event.target.closest('[data-cv-s4-hbpro-gallery-previous]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex - 1);
              return;
            }
            if (event.target.closest('[data-cv-s4-hbpro-gallery-next]')) {
              event.preventDefault();
              this.showGallery(this.galleryIndex + 1);
              return;
            }
          }

          if (event.key === 'ArrowLeft') this.showGallery(this.galleryIndex - 1);
          if (event.key === 'ArrowRight') this.showGallery(this.galleryIndex + 1);
          if (event.key === 'Tab') this.trapFocus(event);
        }, { signal });

        this.dialog.addEventListener('close', () => {
          this.dialogImage?.removeAttribute('src');
          document.documentElement.classList.remove('cv-s4-hbpro-dialog-open');
          this.returnFocus?.focus();
          this.returnFocus = null;
        }, { signal });
      }
    }

    bindLoadingState() {
      if (!this.addButton) return;
      const sync = () => {
        this.addButton = this.root.querySelector('[data-cv-s4-hbpro-add]');
        if (!this.addButton) return;

        const busy = this.addButton.hasAttribute('data-added');
        this.addButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        this.addButton.disabled = !this.currentVariant?.available;

        clearTimeout(this.loadingFallback);
        if (busy) this.loadingFallback = setTimeout(() => this.settleLoadingState(), 3000);
      };

      this.loadingObserver = new MutationObserver(sync);
      this.loadingObserver.observe(this.root, {
        attributes: true,
        attributeFilter: ['data-added'],
        childList: true,
        subtree: true,
      });

      const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
      if (errorRegion) {
        this.errorObserver = new MutationObserver(() => {
          if (errorRegion.textContent.trim()) this.settleLoadingState();
        });
        this.errorObserver.observe(errorRegion, { childList: true, characterData: true, subtree: true });
      }

      sync();
    }

    settleLoadingState() {
      clearTimeout(this.loadingFallback);
      this.addButton = this.root.querySelector('[data-cv-s4-hbpro-add]');
      if (!this.addButton) return;

      this.addButton.removeAttribute('data-added');
      this.addButton.classList.remove('loading');
      this.addButton.setAttribute('aria-busy', 'false');
      this.addButton.disabled = !this.currentVariant?.available;
    }

    async submitNativeFallback(form, submitter) {
      if (form.dataset.cvS4HBPROFallbackSubmitting === 'true') return;

      form.dataset.cvS4HBPROFallbackSubmitting = 'true';
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin',
        });
        const payload = await response.json();

        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add this item to the cart.');
        }

        window.location.assign(Theme.routes.cart_url || '/cart');
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Unable to add this item to the cart.';
        const errorRegion = this.root.querySelector('[ref="addToCartTextError"]');
        if (errorRegion) errorRegion.textContent = message;
        if (this.liveRegion) this.liveRegion.textContent = message;
        form.removeAttribute('data-cv-s4-hbpro-fallback-submitting');
        if (submitter) {
          submitter.removeAttribute('aria-busy');
          submitter.disabled = !this.currentVariant?.available;
        }
      }
    }

    selectedOptions() {
      return this.optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    }

    findByOptions() {
      const options = this.selectedOptions();
      return this.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
    }

    findById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id));
    }

    restoreFromUrl(announce) {
      const id = new URL(window.location.href).searchParams.get('variant') || this.variantInput.value;
      const variant = this.findById(id) || this.findByOptions() || this.variants[0];
      this.checkOptions(variant);
      this.update(variant, { historyMode: 'replace', announce });
    }

    checkOptions(variant) {
      if (!variant) return;
      this.optionGroups.forEach((group, index) => {
        const input = [...group.querySelectorAll('input')].find((node) => node.value === variant.options[index]);
        if (input) input.checked = true;
      });
    }

    update(variant, { historyMode = 'replace', announce = false } = {}) {
      if (!variant) return;
      this.currentVariant = variant;

      this.variantInput.value = variant.id;
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      this.optionGroups.forEach((group) => {
        const output = group.querySelector('[data-cv-s4-hbpro-option-value]');
        const checked = group.querySelector('input:checked');
        if (output && checked) output.textContent = checked.value;
      });

      this.setText('[data-cv-s4-hbpro-price]', variant.priceFormatted);
      this.setText('[data-cv-s4-hbpro-sku]', variant.sku || '—');

      const compare = this.root.querySelector('[data-cv-s4-hbpro-compare]');
      if (compare) {
        compare.hidden = !(variant.compareAt > variant.price);
        compare.textContent = variant.compareAt > variant.price ? variant.compareAtFormatted : '';
      }

      const addButton = this.root.querySelector('[data-cv-s4-hbpro-add]');
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
        const label = addButton.querySelector('[data-cv-s4-hbpro-add-label]');
        if (label) label.textContent = variant.available ? addButton.dataset.readyLabel : addButton.dataset.unavailableLabel;
      }

      this.updateQuantityRules(variant);
      this.updateHero(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      const state = { variantId: variant.id };
      if (historyMode === 'push') window.history.pushState(state, '', url);
      else window.history.replaceState(state, '', url);

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = `${variant.title}. ${variant.priceFormatted}. ${variant.available ? 'Available' : 'Unavailable'}.`;
      }

      window.dispatchEvent(new CustomEvent('cv-s4-hbpro:variant-change', {
        detail: { productId: this.root.dataset.productId, variant },
      }));
    }

    updateQuantityRules(variant) {
      if (!this.quantityInput) return;
      const minimum = Number(variant.quantityMin) || 1;
      const increment = Number(variant.quantityIncrement) || 1;
      this.quantityInput.min = String(minimum);
      this.quantityInput.step = String(increment);
      if (variant.quantityMax == null) this.quantityInput.removeAttribute('max');
      else this.quantityInput.max = String(variant.quantityMax);
      this.normalizeQuantity();
    }

    normalizeQuantity() {
      if (!this.quantityInput) return;
      const minimum = Number(this.quantityInput.min) || 1;
      const maximum = this.quantityInput.max ? Number(this.quantityInput.max) : Infinity;
      const increment = Number(this.quantityInput.step) || 1;
      const raw = Number.parseInt(this.quantityInput.value, 10);
      const safe = Number.isFinite(raw) ? raw : minimum;
      const stepped = minimum + Math.round((safe - minimum) / increment) * increment;
      this.quantityInput.value = String(Math.min(maximum, Math.max(minimum, stepped)));
      const minus = this.root.querySelector('[data-cv-s4-hbpro-quantity-minus]');
      const plus = this.root.querySelector('[data-cv-s4-hbpro-quantity-plus]');
      if (minus) minus.disabled = Number(this.quantityInput.value) <= minimum;
      if (plus) plus.disabled = Number(this.quantityInput.value) >= maximum;
    }

    stepQuantity(direction) {
      if (!this.quantityInput) return;
      const increment = Number(this.quantityInput.step) || 1;
      const current = Number.parseInt(this.quantityInput.value, 10) || Number(this.quantityInput.min) || 1;
      this.quantityInput.value = String(current + direction * increment);
      this.normalizeQuantity();
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateHero(variant) {
      if (!this.heroImage || !variant.image) return;
      this.heroImage.src = variant.image;
      if (variant.srcset) this.heroImage.srcset = variant.srcset;
      else this.heroImage.removeAttribute('srcset');
      this.heroImage.alt = variant.alt || '';
      if (this.mobileSource && !this.mobileSource.srcset) this.mobileSource.removeAttribute('srcset');
    }

    setText(selector, value) {
      const node = this.root.querySelector(selector);
      if (node) node.textContent = value ?? '';
    }

    openGallery(trigger) {
      if (!this.dialog || !this.gallery.length) return;
      this.returnFocus = trigger;
      this.showGallery(0);
      this.dialog.showModal();
      document.documentElement.classList.add('cv-s4-hbpro-dialog-open');
      this.dialog.querySelector('[data-cv-s4-hbpro-gallery-close]')?.focus();
    }

    showGallery(index) {
      if (!this.gallery.length || !this.dialogImage) return;
      this.galleryIndex = (index + this.gallery.length) % this.gallery.length;
      const item = this.gallery[this.galleryIndex];
      this.dialogImage.src = item.src;
      this.dialogImage.alt = item.alt || '';
      if (this.dialogCaption) {
        this.dialogCaption.textContent = item.caption || '';
        this.dialogCaption.hidden = !item.caption;
      }
      const position = this.dialog.querySelector('[data-cv-s4-hbpro-gallery-position]');
      if (position) position.textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
    }

    trapFocus(event) {
      const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((node) => !node.hidden && node.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    closeGallery() {
      if (this.dialog?.open) this.dialog.close();
    }

    destroy() {
      this.abort.abort();
      this.loadingObserver?.disconnect();
      this.errorObserver?.disconnect();
      clearTimeout(this.loadingFallback);
    }
  }

  const initialize = (scope = document) => {
    const roots = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    roots.forEach((root) => {
      if (controllers.has(root)) return;
      controllers.set(root, new CVS4HBPROPurchase(root));
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    if (!root) return;
    controllers.get(root)?.destroy();
    controllers.delete(root);
  });
})();

(() => {
  const readVariants = () => {
    const node = document.querySelector('[data-cv-s4-hbpro-controller] [data-cv-s4-hbpro-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]');
    } catch (_) {
      return [];
    }
  };

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-s4-hbpro-faq]:not([data-cv-s4-hbpro-ready])').forEach((list) => {
      list.dataset.cvS4HBPROReady = 'true';

      const syncExpandedState = (details) => {
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      list.querySelectorAll('details').forEach(syncExpandedState);

      list.addEventListener('keydown', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !list.contains(summary) || !['Enter', ' ', 'Spacebar'].includes(event.key)) return;

        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        details.open = !details.open;
        syncExpandedState(details);
      });

      list.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement)) return;

        syncExpandedState(opened);
        if (!opened.open || list.dataset.multiple === 'true') return;

        list.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };

  const initFinalCta = (root = document) => {
    root.querySelectorAll('[data-cv-s4-hbpro-final-cta]:not([data-cv-s4-hbpro-ready])').forEach((cta) => {
      cta.dataset.cvS4HBPROReady = 'true';
      const finalButton = cta.querySelector('[data-cv-s4-hbpro-final-add]');
      const finalPrice = cta.querySelector('[data-cv-s4-hbpro-final-price]');
      const status = cta.querySelector('[data-cv-s4-hbpro-final-status]');
      const purchase = document.querySelector('[data-cv-s4-hbpro-controller]');
      const variantInput = purchase?.querySelector('[data-cv-s4-hbpro-variant-input]');
      const variants = readVariants();

      if (!finalButton || !purchase || !variantInput) return;

      const currentVariant = () => variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
      const syncVariant = () => {
        const variant = currentVariant();
        if (finalPrice && variant?.priceFormatted) finalPrice.textContent = variant.priceFormatted;
        const unavailable = !variant?.available;
        finalButton.disabled = unavailable;
        finalButton.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      };
      const syncPurchaseState = () => {
        const mainButton = purchase.querySelector('[data-cv-s4-hbpro-add]');
        if (!mainButton) return;
        const busy = mainButton.getAttribute('aria-busy') === 'true' || mainButton.hasAttribute('data-added');
        const unavailable = !currentVariant()?.available;
        finalButton.disabled = busy || unavailable;
        finalButton.setAttribute('aria-disabled', busy || unavailable ? 'true' : 'false');
        finalButton.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (busy && status) status.textContent = 'Adding through the secure product form…';
      };

      variantInput.addEventListener('change', () => {
        syncVariant();
        syncPurchaseState();
      });

      finalButton.addEventListener('click', () => {
        if (status) status.textContent = 'Adding through the secure product form…';
      });

      const purchaseObserver = new MutationObserver(() => {
        syncPurchaseState();
        const error = purchase.querySelector('[ref="addToCartTextError"]')?.textContent?.trim();
        if (error && status) status.textContent = error;
      });
      purchaseObserver.observe(purchase, {
        attributes: true,
        attributeFilter: ['aria-busy', 'data-added', 'disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });

      syncVariant();
      syncPurchaseState();
    });
  };

  const init = (root = document) => {
    initFaq(root);
    initFinalCta(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!window.clearVeroCollectionSortSync) {
    window.clearVeroCollectionSortSync = true;
    document.addEventListener(
      'change',
      (event) => {
        const control = event.target;
        if (!(control instanceof HTMLSelectElement)) return;
        if (control.name !== 'sort_by' || !control.closest('.clearvero-collection')) return;

        document.querySelectorAll('.clearvero-collection [name="sort_by"]').forEach((sortControl) => {
          if (sortControl === control) return;
          if (sortControl instanceof HTMLSelectElement) {
            sortControl.value = control.value;
          } else if (sortControl instanceof HTMLInputElement && sortControl.type === 'radio') {
            sortControl.checked = sortControl.value === control.value;
          }
        });
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();
})();
